/* src/components/ZoomableOutageMapTable/ZoomableOutageMapTable.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append_hydration,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_svg_element,
	claim_text,
	component_subscribe,
	create_component,
	destroy_block,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert_hydration,
	listen,
	mount_component,
	noop,
	null_to_empty,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	set_store_value,
	set_style,
	space,
	svg_element,
	text,
	to_number,
	transition_in,
	transition_out,
	update_keyed_each
} from "svelte/internal";

import { spring } from 'svelte/motion';
import InlineTextCta from '../Bluetti/InlineTextCta.svelte';

// import SolarCTA from '../SolarCTA/SolarCTA.svelte';
// import AffiliateCTA from '../PowerOutageAffiliateCTA//AffiliateCTA.svelte';
import { onMount } from 'svelte';

import getGraphqlClient from '../../helpers/svelte/utils/getGraphqlClient';
import Icon from '../Icon/Icon.svelte';
import StatePath from '../ZoomableMap/components/StatePath/StatePath.svelte';
import PowerOutageCta from '../PowerOutageCta/PowerOutageCta.svelte';
import gql from 'nanographql';
import SortableTable from '../SortableTable/SortableTable.svelte';
import formatDateTimeForText from '../../helpers/formatDateTimeForText';
import getNumberWithOrdinal from '../../helpers/getNumberWithOrdinal';
import { toLocaleString } from '../../consts/error-pages.cjs';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[94] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[94] = list[i];
	return child_ctx;
}

function get_each_context_2(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[99] = list[i];
	return child_ctx;
}

function get_each_context_3(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[102] = list[i];
	child_ctx[104] = i;
	return child_ctx;
}

// (681:2) {#if pageType === 'state'}
function create_if_block_17(ctx) {
	let p0;
	let t0;

	let t1_value = (/*totalCustomersOut*/ ctx[19] !== null && /*totalCustomersOut*/ ctx[19] !== undefined
	? /*totalCustomersOut*/ ctx[19].toLocaleString()
	: '') + "";

	let t1;
	let t2;
	let t3_value = /*currentState*/ ctx[8].name + "";
	let t3;
	let t4;

	let t5_value = (/*statePercentOut*/ ctx[17] !== null && /*statePercentOut*/ ctx[17] !== undefined
	? /*statePercentOut*/ ctx[17]
	: '') + "";

	let t5;
	let t6;

	let t7_value = (/*totalCustomers*/ ctx[18] !== null && /*totalCustomers*/ ctx[18] !== undefined
	? /*totalCustomers*/ ctx[18].toLocaleString()
	: '') + "";

	let t7;
	let t8;

	let t9_value = (/*lastUpdated*/ ctx[20] !== null && /*lastUpdated*/ ctx[20] !== undefined
	? /*lastUpdated*/ ctx[20]
	: '') + "";

	let t9;
	let t10;
	let t11_value = /*currentState*/ ctx[8].name + "";
	let t11;
	let t12;

	let t13_value = (/*stateOutageRank*/ ctx[13] > 0
	? /*stateOutageRank*/ ctx[13] === 1
		? ''
		: getNumberWithOrdinal(/*stateOutageRank*/ ctx[13])
	: '') + "";

	let t13;
	let t14;

	let t15_value = (/*highestRatio*/ ctx[14] !== null && /*highestRatio*/ ctx[14] !== undefined
	? /*highestRatio*/ ctx[14] === 1
		? ''
		: getNumberWithOrdinal(/*highestRatio*/ ctx[14])
	: '') + "";

	let t15;
	let t16;
	let t17;
	let p1;
	let t18;

	let t19_value = (/*countyCount*/ ctx[12] !== null && /*countyCount*/ ctx[12] !== undefined
	? /*countyCount*/ ctx[12]
	: '') + "";

	let t19;
	let t20;

	let t21_value = (/*countyWithHighestOutages*/ ctx[21] !== null && /*countyWithHighestOutages*/ ctx[21] !== undefined
	? /*countyWithHighestOutages*/ ctx[21].name
	: '') + "";

	let t21;
	let t22;

	let t23_value = (/*countyWithHighestOutages*/ ctx[21] !== null && /*countyWithHighestOutages*/ ctx[21].outageCustomers !== undefined
	? /*countyWithHighestOutages*/ ctx[21].outageCustomers.toLocaleString()
	: '') + "";

	let t23;
	let t24;
	let a0;
	let t25;
	let t26;
	let p2;
	let t27;

	let t28_value = (/*highestRatioCounty*/ ctx[22] !== null && /*highestRatioCounty*/ ctx[22] !== undefined
	? /*highestRatioCounty*/ ctx[22].name
	: '') + "";

	let t28;
	let t29;

	let t30_value = (/*highestRatioCounty*/ ctx[22] !== null && /*highestRatioCounty*/ ctx[22].ratio !== undefined
	? /*highestRatioCounty*/ ctx[22].ratio.toFixed(2)
	: '') + "";

	let t30;
	let t31;
	let t32;
	let p3;
	let t33;

	let t34_value = (/*utilityCount*/ ctx[15] !== null && /*utilityCount*/ ctx[15] !== undefined
	? /*utilityCount*/ ctx[15]
	: '') + "";

	let t34;
	let t35;
	let t36_value = /*currentState*/ ctx[8].name + "";
	let t36;
	let t37;

	let t38_value = (/*providerHighestOutages*/ ctx[16] !== null && /*providerHighestOutages*/ ctx[16] !== undefined
	? /*providerHighestOutages*/ ctx[16].companyNameSeo
	: '') + "";

	let t38;
	let t39;

	let t40_value = (/*providerHighestOutages*/ ctx[16] !== null && /*providerHighestOutages*/ ctx[16].outageCustomers !== undefined
	? /*providerHighestOutages*/ ctx[16].outageCustomers.toLocaleString()
	: '') + "";

	let t40;
	let t41;
	let a1;
	let t42;
	let t43;
	let p4;
	let t44;

	let t45_value = (/*providerHighestRatio*/ ctx[23] !== null && /*providerHighestRatio*/ ctx[23] !== undefined
	? /*providerHighestRatio*/ ctx[23].companyNameSeo
	: '') + "";

	let t45;
	let t46;

	let t47_value = (/*providerHighestRatio*/ ctx[23] !== null && /*providerHighestRatio*/ ctx[23].ratio !== undefined
	? `${/*providerHighestRatio*/ ctx[23].ratio.toFixed(2)}%`
	: '') + "";

	let t47;
	let t48;
	let t49;
	let inlinetextcta;
	let current;
	inlinetextcta = new InlineTextCta({});

	return {
		c() {
			p0 = element("p");
			t0 = text("There are currently ");
			t1 = text(t1_value);
			t2 = text(" homes and businesses without power in ");
			t3 = text(t3_value);
			t4 = text(". This represents\n      ");
			t5 = text(t5_value);
			t6 = text("% of the\n      ");
			t7 = text(t7_value);
			t8 = text(" customers we track\n      in the state as of\n      ");
			t9 = text(t9_value);
			t10 = text(". ");
			t11 = text(t11_value);
			t12 = text(" currently has the\n      ");
			t13 = text(t13_value);
			t14 = text(" most power outages\n      of any state and the\n      ");
			t15 = text(t15_value);
			t16 = text(" highest ratio of customers out of any state.");
			t17 = space();
			p1 = element("p");
			t18 = text("Of the ");
			t19 = text(t19_value);
			t20 = text(" counties in the state,\n      ");
			t21 = text(t21_value);
			t22 = text("\n      currently has the most outages, at\n      ");
			t23 = text(t23_value);
			t24 = text(" customers without power. For a ");
			a0 = element("a");
			t25 = text("full county list see below.");
			t26 = space();
			p2 = element("p");
			t27 = text("The county with the largest percentage of customers out is\n      ");
			t28 = text(t28_value);
			t29 = text(", at\n      ");
			t30 = text(t30_value);
			t31 = text("% of customers without power.");
			t32 = space();
			p3 = element("p");
			t33 = text("Of the ");
			t34 = text(t34_value);
			t35 = text(" utilities we track in ");
			t36 = text(t36_value);
			t37 = text(",\n      ");
			t38 = text(t38_value);
			t39 = text(" has the most customers out, with\n      ");
			t40 = text(t40_value);
			t41 = text(" without power. ");
			a1 = element("a");
			t42 = text("See full list below.");
			t43 = space();
			p4 = element("p");
			t44 = text("The utility with the largest percentage of customers out is\n      ");
			t45 = text(t45_value);
			t46 = text(",\n      at\n      ");
			t47 = text(t47_value);
			t48 = text(" of customers without power.");
			t49 = space();
			create_component(inlinetextcta.$$.fragment);
			this.h();
		},
		l(nodes) {
			p0 = claim_element(nodes, "P", {});
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "There are currently ");
			t1 = claim_text(p0_nodes, t1_value);
			t2 = claim_text(p0_nodes, " homes and businesses without power in ");
			t3 = claim_text(p0_nodes, t3_value);
			t4 = claim_text(p0_nodes, ". This represents\n      ");
			t5 = claim_text(p0_nodes, t5_value);
			t6 = claim_text(p0_nodes, "% of the\n      ");
			t7 = claim_text(p0_nodes, t7_value);
			t8 = claim_text(p0_nodes, " customers we track\n      in the state as of\n      ");
			t9 = claim_text(p0_nodes, t9_value);
			t10 = claim_text(p0_nodes, ". ");
			t11 = claim_text(p0_nodes, t11_value);
			t12 = claim_text(p0_nodes, " currently has the\n      ");
			t13 = claim_text(p0_nodes, t13_value);
			t14 = claim_text(p0_nodes, " most power outages\n      of any state and the\n      ");
			t15 = claim_text(p0_nodes, t15_value);
			t16 = claim_text(p0_nodes, " highest ratio of customers out of any state.");
			p0_nodes.forEach(detach);
			t17 = claim_space(nodes);
			p1 = claim_element(nodes, "P", {});
			var p1_nodes = children(p1);
			t18 = claim_text(p1_nodes, "Of the ");
			t19 = claim_text(p1_nodes, t19_value);
			t20 = claim_text(p1_nodes, " counties in the state,\n      ");
			t21 = claim_text(p1_nodes, t21_value);
			t22 = claim_text(p1_nodes, "\n      currently has the most outages, at\n      ");
			t23 = claim_text(p1_nodes, t23_value);
			t24 = claim_text(p1_nodes, " customers without power. For a ");
			a0 = claim_element(p1_nodes, "A", { href: true });
			var a0_nodes = children(a0);
			t25 = claim_text(a0_nodes, "full county list see below.");
			a0_nodes.forEach(detach);
			p1_nodes.forEach(detach);
			t26 = claim_space(nodes);
			p2 = claim_element(nodes, "P", {});
			var p2_nodes = children(p2);
			t27 = claim_text(p2_nodes, "The county with the largest percentage of customers out is\n      ");
			t28 = claim_text(p2_nodes, t28_value);
			t29 = claim_text(p2_nodes, ", at\n      ");
			t30 = claim_text(p2_nodes, t30_value);
			t31 = claim_text(p2_nodes, "% of customers without power.");
			p2_nodes.forEach(detach);
			t32 = claim_space(nodes);
			p3 = claim_element(nodes, "P", {});
			var p3_nodes = children(p3);
			t33 = claim_text(p3_nodes, "Of the ");
			t34 = claim_text(p3_nodes, t34_value);
			t35 = claim_text(p3_nodes, " utilities we track in ");
			t36 = claim_text(p3_nodes, t36_value);
			t37 = claim_text(p3_nodes, ",\n      ");
			t38 = claim_text(p3_nodes, t38_value);
			t39 = claim_text(p3_nodes, " has the most customers out, with\n      ");
			t40 = claim_text(p3_nodes, t40_value);
			t41 = claim_text(p3_nodes, " without power. ");
			a1 = claim_element(p3_nodes, "A", { href: true });
			var a1_nodes = children(a1);
			t42 = claim_text(a1_nodes, "See full list below.");
			a1_nodes.forEach(detach);
			p3_nodes.forEach(detach);
			t43 = claim_space(nodes);
			p4 = claim_element(nodes, "P", {});
			var p4_nodes = children(p4);
			t44 = claim_text(p4_nodes, "The utility with the largest percentage of customers out is\n      ");
			t45 = claim_text(p4_nodes, t45_value);
			t46 = claim_text(p4_nodes, ",\n      at\n      ");
			t47 = claim_text(p4_nodes, t47_value);
			t48 = claim_text(p4_nodes, " of customers without power.");
			p4_nodes.forEach(detach);
			t49 = claim_space(nodes);
			claim_component(inlinetextcta.$$.fragment, nodes);
			this.h();
		},
		h() {
			attr(a0, "href", "#county-list");
			attr(a1, "href", "#utility-list");
		},
		m(target, anchor) {
			insert_hydration(target, p0, anchor);
			append_hydration(p0, t0);
			append_hydration(p0, t1);
			append_hydration(p0, t2);
			append_hydration(p0, t3);
			append_hydration(p0, t4);
			append_hydration(p0, t5);
			append_hydration(p0, t6);
			append_hydration(p0, t7);
			append_hydration(p0, t8);
			append_hydration(p0, t9);
			append_hydration(p0, t10);
			append_hydration(p0, t11);
			append_hydration(p0, t12);
			append_hydration(p0, t13);
			append_hydration(p0, t14);
			append_hydration(p0, t15);
			append_hydration(p0, t16);
			insert_hydration(target, t17, anchor);
			insert_hydration(target, p1, anchor);
			append_hydration(p1, t18);
			append_hydration(p1, t19);
			append_hydration(p1, t20);
			append_hydration(p1, t21);
			append_hydration(p1, t22);
			append_hydration(p1, t23);
			append_hydration(p1, t24);
			append_hydration(p1, a0);
			append_hydration(a0, t25);
			insert_hydration(target, t26, anchor);
			insert_hydration(target, p2, anchor);
			append_hydration(p2, t27);
			append_hydration(p2, t28);
			append_hydration(p2, t29);
			append_hydration(p2, t30);
			append_hydration(p2, t31);
			insert_hydration(target, t32, anchor);
			insert_hydration(target, p3, anchor);
			append_hydration(p3, t33);
			append_hydration(p3, t34);
			append_hydration(p3, t35);
			append_hydration(p3, t36);
			append_hydration(p3, t37);
			append_hydration(p3, t38);
			append_hydration(p3, t39);
			append_hydration(p3, t40);
			append_hydration(p3, t41);
			append_hydration(p3, a1);
			append_hydration(a1, t42);
			insert_hydration(target, t43, anchor);
			insert_hydration(target, p4, anchor);
			append_hydration(p4, t44);
			append_hydration(p4, t45);
			append_hydration(p4, t46);
			append_hydration(p4, t47);
			append_hydration(p4, t48);
			insert_hydration(target, t49, anchor);
			mount_component(inlinetextcta, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*totalCustomersOut*/ 524288) && t1_value !== (t1_value = (/*totalCustomersOut*/ ctx[19] !== null && /*totalCustomersOut*/ ctx[19] !== undefined
			? /*totalCustomersOut*/ ctx[19].toLocaleString()
			: '') + "")) set_data(t1, t1_value);

			if ((!current || dirty[0] & /*currentState*/ 256) && t3_value !== (t3_value = /*currentState*/ ctx[8].name + "")) set_data(t3, t3_value);

			if ((!current || dirty[0] & /*statePercentOut*/ 131072) && t5_value !== (t5_value = (/*statePercentOut*/ ctx[17] !== null && /*statePercentOut*/ ctx[17] !== undefined
			? /*statePercentOut*/ ctx[17]
			: '') + "")) set_data(t5, t5_value);

			if ((!current || dirty[0] & /*totalCustomers*/ 262144) && t7_value !== (t7_value = (/*totalCustomers*/ ctx[18] !== null && /*totalCustomers*/ ctx[18] !== undefined
			? /*totalCustomers*/ ctx[18].toLocaleString()
			: '') + "")) set_data(t7, t7_value);

			if ((!current || dirty[0] & /*lastUpdated*/ 1048576) && t9_value !== (t9_value = (/*lastUpdated*/ ctx[20] !== null && /*lastUpdated*/ ctx[20] !== undefined
			? /*lastUpdated*/ ctx[20]
			: '') + "")) set_data(t9, t9_value);

			if ((!current || dirty[0] & /*currentState*/ 256) && t11_value !== (t11_value = /*currentState*/ ctx[8].name + "")) set_data(t11, t11_value);

			if ((!current || dirty[0] & /*stateOutageRank*/ 8192) && t13_value !== (t13_value = (/*stateOutageRank*/ ctx[13] > 0
			? /*stateOutageRank*/ ctx[13] === 1
				? ''
				: getNumberWithOrdinal(/*stateOutageRank*/ ctx[13])
			: '') + "")) set_data(t13, t13_value);

			if ((!current || dirty[0] & /*highestRatio*/ 16384) && t15_value !== (t15_value = (/*highestRatio*/ ctx[14] !== null && /*highestRatio*/ ctx[14] !== undefined
			? /*highestRatio*/ ctx[14] === 1
				? ''
				: getNumberWithOrdinal(/*highestRatio*/ ctx[14])
			: '') + "")) set_data(t15, t15_value);

			if ((!current || dirty[0] & /*countyCount*/ 4096) && t19_value !== (t19_value = (/*countyCount*/ ctx[12] !== null && /*countyCount*/ ctx[12] !== undefined
			? /*countyCount*/ ctx[12]
			: '') + "")) set_data(t19, t19_value);

			if ((!current || dirty[0] & /*countyWithHighestOutages*/ 2097152) && t21_value !== (t21_value = (/*countyWithHighestOutages*/ ctx[21] !== null && /*countyWithHighestOutages*/ ctx[21] !== undefined
			? /*countyWithHighestOutages*/ ctx[21].name
			: '') + "")) set_data(t21, t21_value);

			if ((!current || dirty[0] & /*countyWithHighestOutages*/ 2097152) && t23_value !== (t23_value = (/*countyWithHighestOutages*/ ctx[21] !== null && /*countyWithHighestOutages*/ ctx[21].outageCustomers !== undefined
			? /*countyWithHighestOutages*/ ctx[21].outageCustomers.toLocaleString()
			: '') + "")) set_data(t23, t23_value);

			if ((!current || dirty[0] & /*highestRatioCounty*/ 4194304) && t28_value !== (t28_value = (/*highestRatioCounty*/ ctx[22] !== null && /*highestRatioCounty*/ ctx[22] !== undefined
			? /*highestRatioCounty*/ ctx[22].name
			: '') + "")) set_data(t28, t28_value);

			if ((!current || dirty[0] & /*highestRatioCounty*/ 4194304) && t30_value !== (t30_value = (/*highestRatioCounty*/ ctx[22] !== null && /*highestRatioCounty*/ ctx[22].ratio !== undefined
			? /*highestRatioCounty*/ ctx[22].ratio.toFixed(2)
			: '') + "")) set_data(t30, t30_value);

			if ((!current || dirty[0] & /*utilityCount*/ 32768) && t34_value !== (t34_value = (/*utilityCount*/ ctx[15] !== null && /*utilityCount*/ ctx[15] !== undefined
			? /*utilityCount*/ ctx[15]
			: '') + "")) set_data(t34, t34_value);

			if ((!current || dirty[0] & /*currentState*/ 256) && t36_value !== (t36_value = /*currentState*/ ctx[8].name + "")) set_data(t36, t36_value);

			if ((!current || dirty[0] & /*providerHighestOutages*/ 65536) && t38_value !== (t38_value = (/*providerHighestOutages*/ ctx[16] !== null && /*providerHighestOutages*/ ctx[16] !== undefined
			? /*providerHighestOutages*/ ctx[16].companyNameSeo
			: '') + "")) set_data(t38, t38_value);

			if ((!current || dirty[0] & /*providerHighestOutages*/ 65536) && t40_value !== (t40_value = (/*providerHighestOutages*/ ctx[16] !== null && /*providerHighestOutages*/ ctx[16].outageCustomers !== undefined
			? /*providerHighestOutages*/ ctx[16].outageCustomers.toLocaleString()
			: '') + "")) set_data(t40, t40_value);

			if ((!current || dirty[0] & /*providerHighestRatio*/ 8388608) && t45_value !== (t45_value = (/*providerHighestRatio*/ ctx[23] !== null && /*providerHighestRatio*/ ctx[23] !== undefined
			? /*providerHighestRatio*/ ctx[23].companyNameSeo
			: '') + "")) set_data(t45, t45_value);

			if ((!current || dirty[0] & /*providerHighestRatio*/ 8388608) && t47_value !== (t47_value = (/*providerHighestRatio*/ ctx[23] !== null && /*providerHighestRatio*/ ctx[23].ratio !== undefined
			? `${/*providerHighestRatio*/ ctx[23].ratio.toFixed(2)}%`
			: '') + "")) set_data(t47, t47_value);
		},
		i(local) {
			if (current) return;
			transition_in(inlinetextcta.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inlinetextcta.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(p0);
			if (detaching) detach(t17);
			if (detaching) detach(p1);
			if (detaching) detach(t26);
			if (detaching) detach(p2);
			if (detaching) detach(t32);
			if (detaching) detach(p3);
			if (detaching) detach(t43);
			if (detaching) detach(p4);
			if (detaching) detach(t49);
			destroy_component(inlinetextcta, detaching);
		}
	};
}

// (737:2) {#if pageType !== 'all'}
function create_if_block_16(ctx) {
	let section;
	let div3;
	let div0;
	let p0;
	let t0;
	let t1;
	let p1;

	let t2_value = (/*totalCustomers*/ ctx[18] !== null && /*totalCustomers*/ ctx[18] !== undefined
	? /*totalCustomers*/ ctx[18].toLocaleString()
	: 'Loading') + "";

	let t2;
	let t3;
	let div1;
	let p2;
	let t4;
	let t5;
	let p3;

	let t6_value = (/*totalCustomersOut*/ ctx[19] !== null && /*totalCustomersOut*/ ctx[19] !== undefined
	? /*totalCustomersOut*/ ctx[19].toLocaleString()
	: 'Loading') + "";

	let t6;
	let t7;
	let div2;
	let p4;
	let t8;
	let t9;
	let p5;

	let t10_value = (/*lastUpdated*/ ctx[20] !== null && /*lastUpdated*/ ctx[20] !== undefined
	? /*lastUpdated*/ ctx[20]
	: 'Loading') + "";

	let t10;

	return {
		c() {
			section = element("section");
			div3 = element("div");
			div0 = element("div");
			p0 = element("p");
			t0 = text("Customers Tracked:");
			t1 = space();
			p1 = element("p");
			t2 = text(t2_value);
			t3 = space();
			div1 = element("div");
			p2 = element("p");
			t4 = text("Customers Out:");
			t5 = space();
			p3 = element("p");
			t6 = text(t6_value);
			t7 = space();
			div2 = element("div");
			p4 = element("p");
			t8 = text("Last Updated:");
			t9 = space();
			p5 = element("p");
			t10 = text(t10_value);
			this.h();
		},
		l(nodes) {
			section = claim_element(nodes, "SECTION", { class: true });
			var section_nodes = children(section);
			div3 = claim_element(section_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			div0 = claim_element(div3_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			p0 = claim_element(div0_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "Customers Tracked:");
			p0_nodes.forEach(detach);
			t1 = claim_space(div0_nodes);
			p1 = claim_element(div0_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t2 = claim_text(p1_nodes, t2_value);
			p1_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t3 = claim_space(div3_nodes);
			div1 = claim_element(div3_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			p2 = claim_element(div1_nodes, "P", { class: true });
			var p2_nodes = children(p2);
			t4 = claim_text(p2_nodes, "Customers Out:");
			p2_nodes.forEach(detach);
			t5 = claim_space(div1_nodes);
			p3 = claim_element(div1_nodes, "P", { class: true });
			var p3_nodes = children(p3);
			t6 = claim_text(p3_nodes, t6_value);
			p3_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			t7 = claim_space(div3_nodes);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			p4 = claim_element(div2_nodes, "P", { class: true });
			var p4_nodes = children(p4);
			t8 = claim_text(p4_nodes, "Last Updated:");
			p4_nodes.forEach(detach);
			t9 = claim_space(div2_nodes);
			p5 = claim_element(div2_nodes, "P", { class: true });
			var p5_nodes = children(p5);
			t10 = claim_text(p5_nodes, t10_value);
			p5_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			section_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p0, "class", "card-grid__title");
			attr(p1, "class", "card-grid__data");
			attr(div0, "class", "card-grid__item");
			attr(p2, "class", "card-grid__title");
			attr(p3, "class", "card-grid__data");
			attr(div1, "class", "card-grid__item");
			attr(p4, "class", "card-grid__title");
			attr(p5, "class", "card-grid__data");
			attr(div2, "class", "card-grid__item");
			attr(div3, "class", "card-grid");
			attr(section, "class", "section-gap");
		},
		m(target, anchor) {
			insert_hydration(target, section, anchor);
			append_hydration(section, div3);
			append_hydration(div3, div0);
			append_hydration(div0, p0);
			append_hydration(p0, t0);
			append_hydration(div0, t1);
			append_hydration(div0, p1);
			append_hydration(p1, t2);
			append_hydration(div3, t3);
			append_hydration(div3, div1);
			append_hydration(div1, p2);
			append_hydration(p2, t4);
			append_hydration(div1, t5);
			append_hydration(div1, p3);
			append_hydration(p3, t6);
			append_hydration(div3, t7);
			append_hydration(div3, div2);
			append_hydration(div2, p4);
			append_hydration(p4, t8);
			append_hydration(div2, t9);
			append_hydration(div2, p5);
			append_hydration(p5, t10);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*totalCustomers*/ 262144 && t2_value !== (t2_value = (/*totalCustomers*/ ctx[18] !== null && /*totalCustomers*/ ctx[18] !== undefined
			? /*totalCustomers*/ ctx[18].toLocaleString()
			: 'Loading') + "")) set_data(t2, t2_value);

			if (dirty[0] & /*totalCustomersOut*/ 524288 && t6_value !== (t6_value = (/*totalCustomersOut*/ ctx[19] !== null && /*totalCustomersOut*/ ctx[19] !== undefined
			? /*totalCustomersOut*/ ctx[19].toLocaleString()
			: 'Loading') + "")) set_data(t6, t6_value);

			if (dirty[0] & /*lastUpdated*/ 1048576 && t10_value !== (t10_value = (/*lastUpdated*/ ctx[20] !== null && /*lastUpdated*/ ctx[20] !== undefined
			? /*lastUpdated*/ ctx[20]
			: 'Loading') + "")) set_data(t10, t10_value);
		},
		d(detaching) {
			if (detaching) detach(section);
		}
	};
}

// (776:2) {#if pageType === 'all' || pageType === 'state'}
function create_if_block_9(ctx) {
	let div1;
	let t0;
	let t1;
	let div0;
	let svg;
	let rect;
	let g2;
	let g0;
	let each_blocks_1 = [];
	let each0_lookup = new Map();
	let g1;
	let path0;
	let path0_style_value;
	let g2_style_value;
	let g2_transform_value;
	let pattern;
	let path1;
	let svg_viewBox_value;
	let t2;
	let div1_class_value;
	let current;
	let mounted;
	let dispose;
	let if_block0 = /*hoveredEntity*/ ctx[29] && create_if_block_13(ctx);
	let if_block1 = /*selected*/ ctx[10] && create_if_block_12(ctx);
	let each_value_3 = /*counties*/ ctx[34];
	const get_key = ctx => /*county*/ ctx[102];

	for (let i = 0; i < each_value_3.length; i += 1) {
		let child_ctx = get_each_context_3(ctx, each_value_3, i);
		let key = get_key(child_ctx);
		each0_lookup.set(key, each_blocks_1[i] = create_each_block_3(key, child_ctx));
	}

	let each_value_2 = /*states*/ ctx[0];
	let each_blocks = [];

	for (let i = 0; i < each_value_2.length; i += 1) {
		each_blocks[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	let if_block2 = /*nationalInfo*/ ctx[28] && create_if_block_10(ctx);

	return {
		c() {
			div1 = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			div0 = element("div");
			svg = svg_element("svg");
			rect = svg_element("rect");
			g2 = svg_element("g");
			g0 = svg_element("g");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			g1 = svg_element("g");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			path0 = svg_element("path");
			pattern = svg_element("pattern");
			path1 = svg_element("path");
			t2 = space();
			if (if_block2) if_block2.c();
			this.h();
		},
		l(nodes) {
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			if (if_block0) if_block0.l(div1_nodes);
			t0 = claim_space(div1_nodes);
			if (if_block1) if_block1.l(div1_nodes);
			t1 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", {});
			var div0_nodes = children(div0);

			svg = claim_svg_element(div0_nodes, "svg", {
				xmlns: true,
				width: true,
				height: true,
				viewBox: true,
				class: true
			});

			var svg_nodes = children(svg);

			rect = claim_svg_element(svg_nodes, "rect", {
				class: true,
				width: true,
				height: true,
				d: true
			});

			children(rect).forEach(detach);
			g2 = claim_svg_element(svg_nodes, "g", { style: true, transform: true });
			var g2_nodes = children(g2);
			g0 = claim_svg_element(g2_nodes, "g", { id: true, class: true });
			var g0_nodes = children(g0);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].l(g0_nodes);
			}

			g0_nodes.forEach(detach);
			g1 = claim_svg_element(g2_nodes, "g", { id: true });
			var g1_nodes = children(g1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(g1_nodes);
			}

			g1_nodes.forEach(detach);

			path0 = claim_svg_element(g2_nodes, "path", {
				id: true,
				style: true,
				d: true,
				class: true
			});

			children(path0).forEach(detach);
			g2_nodes.forEach(detach);

			pattern = claim_svg_element(svg_nodes, "pattern", {
				id: true,
				patternUnits: true,
				width: true,
				height: true,
				style: true
			});

			var pattern_nodes = children(pattern);
			path1 = claim_svg_element(pattern_nodes, "path", { d: true, style: true });
			children(path1).forEach(detach);
			pattern_nodes.forEach(detach);
			svg_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t2 = claim_space(div1_nodes);
			if (if_block2) if_block2.l(div1_nodes);
			div1_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(rect, "class", "background svelte-6mapeg");
			attr(rect, "width", /*width*/ ctx[5]);
			attr(rect, "height", /*height*/ ctx[4]);
			attr(rect, "d", "M0 0h960v500H0z");
			attr(g0, "id", "counties");
			attr(g0, "class", "svelte-6mapeg");
			attr(g1, "id", "states");
			attr(path0, "id", "state-borders");

			attr(path0, "style", path0_style_value = /*mapStrokeColor*/ ctx[9]
			? `stroke: ${/*mapStrokeColor*/ ctx[9]};`
			: '');

			attr(path0, "d", "M598.907 124.82l-1.804-1.646.994-2.696-3.173-.067\n              1.027-2.878-.666-1.161.534-1.999-.92-.846-2.843-.845h0l-1.088-.674.125-1.88-5.214-1.377-2.272.238-3.336-.852-.777-.395-1.356-.673-11.008-2.258.015.23-.015-.23-2.544-.531-1.391-2.992-2.656-1.023M140.862\n              59.559l1.144.065 2.233 2.645.267 4.605-.414 2.27-.2 1.538 1.19 1.116 4.576 2.434 4.578-.68 1.775-.608\n              3.702.67.813.754 2.787 1.353.523 1.296 1.559-.555 1.551.729 3.722-.865 1.97 1.34 3.536.367 3.133-.897 1.782.014\n              2.588.258 1.492-.945 1.776.593 3.87.689 2.113-.767 12.515 2.997.227.054 4.761 1.142 1.54.375 7.127 1.678m263.446\n              76.439l.032-6.549h0l.03-6.513.032-6.489.055-1.649.016-3.266-.033-3.206.026-5.442-.23-1.075-2.768-1.602-1.947-3.286-.131-1.034\n              2.31-1.747\n              1.227-1.766.152-1.943-8.635-.081-9.753-.175-.373-.008-9.33-.292-3.639-.13-9.328-.34-2.051-.103-8.251-.405-19.243-1.085-12.246-.835-.697-.062-13.585-1.077M105.56\n              130.611l5.14 1.624 4.013 1.086 3.852 1.1 12.473 3.512 11.138 3.329 7.527 2.103 11.728 3.053 8.525 2.2.48.12\n              15.103 3.626 15.722 3.576 6.928-30.801h0l.659-2.929.725-.59 1.095-1.808-.262-1.246\n              1.405-1.666-2.274-2.986-1.313-.7.71-3.345 1.005-.546 2.393-3.686 2.289-1.31 2.452-4.033 2.01-3.174 2.615-3.996\n              1.568-1.453-.401-2.767-2.828-2.811-.939-2.869-.465-1.972 1.046-1.264-.998-3.609.59-1.354.002-.01.47-2.088\n              2.391-10.624.537-2.385.438-1.946 2.487-11.05.28-1.242 3.295-14.435.618-2.746m596.098\n              93.127l-.165-1.72-3.103-2.18-.457-2.998-1.543-4.426h0l-.014-.048-2.673-8.82-2.78-8.864-3.141-9.327M784.599\n              95.94l.225 3.14 1.518 5.041.351.236 1.087 1.846.49 3.225-.66 1.538.518 3.158 1.32 3.814.43.953-.322 2.359.72\n              1.121.959-1.373 1.031 1.17.967 4.37 1.415 6.828 1.024 3.582 3.206-.692 1.242-.276\n              6.276-1.331-1.464-1.203-.381-2.91.79-1.053-.852-2.77-.095-1.37-.854-6.325.522-.694-.105-1.98.95-1.542.148-4.466.664-1.657-.464-1.419-.678-3.015\n              2.373-1.134.697-1.304 1.945-2.37.118-1.612-2.011-2.787.998-3.296-.576-1.812m-419.19-36.907l-.57 6.728-.383\n              4.51-.57 7.255-.94 11.066-.105 1.242-1.083 12.765-.158 1.863-.411 4.845-.527 6.206-.1 1.178-1.01 12.457-.575\n              3.992-12.865-1.22-.66-.064-12.305-1.11-3.107-.333-10.813-1.28-10.75-1.398-4.418-.524-4.878-.663-15.372-2.18-11.87-1.6-4.367-.873-1.176\n              6.162-.429 3.587-1.446 9.063-1.38 8.95-.547 3.424-.876 5.487-1.55 9.4-1.516 9.494-1.203 7.851-1.021 6.083-.753\n              4.714 13.782 2.146.694.104 13.12 1.818 15.722 2.047 8.318 1.001 6.375.768 7.473.897 1.794.204 12.727 1.308\n              4.645.447 12.398\n              1.05.624-7.345.273-3.214.213-2.508.483-5.688.97-11.421.625-7.36.703-8.855.041-.482.556-6.545.455-5.357.063-.743.62-7.287.628-7.955m98.816-13.034l-.13-1.614.242-1.55-.532-4.218-1.741-2.884-.58-2.704-.184-.012-.017-3.488.567-1.814-.95-1.696-.069-2.675.106-1.616-.23-4.869-.471-3.243-1.99-5.078-1.08-4.21.049-.347.32-4.19-.466-2.29.792-2.58-1.089-2.423-.446-3.455M282.174\n              171.452l-6.255-.974-8.204-1.325-.776-.154-11.3-2.002-14.117-2.54-3.254-.63-10.227-2.085-9.83-2.046-16.811-3.694-.139-.062m605.135-21.291l2.35-.493\n              4.736-1.04.382-.088 8.072-1.837.294-.8-.008-.028.11-.155 2.053-1.792.173-1.05 2.761-1.017m-31.527\n              24.025l-.144.035-.281-.535.16-8.34.145-4.586m-416.24 27.406l7.428.69 6.805.52 2.82.205 9.63.664 11.58.72\n              13.975.683 9.011.377 3.752.134 10.282.301 2.53 2.244 2.13.878v-.02l1.581 1.468 1.326-.205 1.403-1.728 2.729.383\n              2.05.064 2.4-.298 1.986 1.297 1.948.739 2.877 1.107 1.412 1.02.916 2.38 2.55.66-.73-1.326-1.74-3.967\n              1.237-2.585.405-2.641.782-.632-.231-2.431-1.113-.873.402-2.519-.956-2.011 1.935.01 5.42.015 2.566-.001\n              5.468-.03.92.005 6.388-.057.774-.02 5.565-.069 2.662-.046 3.726-.054 4.306-.1 2.08-.052 6.047-.174.29-.009\n              6.336-.234 1.451-.054 4.98-.206 4.69-.202 1.596-.073 5.317-.256.22 1.462-.043 1.082 2.187 1.907-1.432 3.406.38\n              1.708 1.607 4.605 2.166 1.088v.01l2.733.629.965 2.301 2.942-.149 6.862-.4 1.176-.077 5.984-.3.49-.025 5.787-.326\n              2.257-.11.928-.1 5.482-.454 1.467-.13 5.388-.404m182.5 19.302l.864-1.262\n              3.11-2.603-.003-.01-3.823-2.88-1.891-1.028-.668-2.287-1.875-.525-.167-.284-.35-3.198 1.285-2.09-1.329-1.57\n              1.535-2.78-.333.117.789-1.058.538-2.838\n              1.581-1.832-1.019-1.106-3.399-.34-1.613-1.96-.964-3.854-1.032-.525-1.636.178-1.963-2.226-1.587.38-8.42\n              1.787-.531.113-5.567 1.167-4.99 1.025-.534.109-8.682 1.732-1.882.429-6.18 1.124-1.36.257-8.307\n              1.598-1.908.284-7.441 1.38-2.101.333-.866-5.016M561.91 176.243l.042.746 2.4 1.511 1.251 2.82 1.071.564 2.148\n              1.175.304 1.722.168 1.933-.257 2.273-.86.559-.93 1.079-.197 2.543-1.611 1.421-4.402 1.576-3.5.835-.366\n              1.62v.02l-.458 1.775 1.727 1.408.738 1.622.001.03-.055 2.748-1.707 1.994-.178 2.42-1 1.166-2.289.692-.054\n              4.075-.645.274-4.384-3.959-3.182-.002-3.322.25-2.418.155-4.03.26-1.058.068-5.393.277-3.883.184-2.573.068-3.076.126-3.38.146-3.026.1-3.381.09-2.221.013-3.988-.02-4.039-.03-2.422-.012-5.502-.066-1.719-2.557.754-1.185.247-2.206-.908-2.861-.05-.06.048-1.953-.602-.575.698-1.842-.9-1.93-.848-2.183-1.345-.567-.395-2.75.797-2.223-.99-1.213.102-2.041-1.976-1.378.103-1.243-1.228-1.913.005-1.161-.832-1.336.5-1.725-.88-.953m347.494-26.255l-.934-2.91-.94-.052m-166.851\n              32.087l-3.818.674-1.617.27-6.572 1.08-.54.086-5.55.852m154.897-14.183l-1.385-1.697\n              2.8-2.919-1.504-2.612-.512-2.976-.473-2.6-1.256-7.108 5.809-1.218.628-.134 6.69-1.576\n              4.997-1.209.003.01.436-.091 4.12-.658 1.535 5.113.4 1.536.204.782.668 3.357-.22 1.729m-38.627 8.927l5.182 1.797\n              2.044.615.283.111 4.83 1.493m-633.343-24.54l-3.814 14.78-6.881 26.671-1.34 4.987-.672 2.4-.66\n              2.758-.247.961-.213.824-.274 1.268.992 1.531 3.516 5.257 2.722 4.06 1.868 2.814 7.968 12.022 6.558 9.915 7.494\n              11.277 14.59 21.925 2.785 4.261 12.018 18.02 1.407-2.341.37-3.548-.643-3.43.803-2.1-.417-1.775\n              1.247-2.952-.795-2.336.233-1.988 2.082-.566 3.18.504 2.099 2.978 1.302.057 2.133-2.847 2.21-12.064.56-2.914\n              16.732 3.112 5.22.928 16.416 2.765 9.69 1.52 10.938 1.78 13.965 1.97 1.253-9.072 1.073-7.388.702-5.087.638-6.518\n              2.341-16.18.338-2.447.42-3.039 1.45-10.49 1.112-8.05.894-6.463m415.84 16.214l-4.022.72-2.165.372-7.056\n              1.166-1.411.232-.735-4.475-.116-1.017-.488-2.66-.68-4.452-.29-1.45-.494-3.005m-302.261 26.912l9.09.57 1.22.058\n              8.026.437.254.012 7.725.374.204.009 7.829.321 6.356.218 1.577.052 4.831.147 3.154.087 3.255.071 4.832.117\n              1.577.032 6.41.117 6.41.077 1.578.015 4.834.042 3.205.022 3.206.004 3.154-.003\n              6.36-.019.408-.003-1.43-.689.297-1.419-2.3-2.79-.05-.061-2.195-4.87-.76-1.161m156.781 18.469l-.655\n              1.484.001.01.388 2.412 1.174.688-.057 1.282-3.02.904-2.37 1.608-2-.63-1.473.34.449 2.62.027 1.179-2.26\n              1.789-.388 1.224-1.27 2.289-.717-.33-1.385 2.247-.333 3.285-.714.208-3.896-.551-1.239-2.358-1.806 1.334-.274\n              1.453-.039 2.233-1.136.215-.842 1.6-2.579-2.699-2.274 1.5-1.079\n              2.504-3.054-1.14-.503-.32-2.263-.607-.728.676-1.515-1.076.027 2.683-1.312-1.156.001.01-3.293.213.457\n              1.66-1.809.396-1.675 2.65.51 1.697 1.158 1.225-.265.622-2.858.611-1.082 1.002-.818-.31.002.03-.846.667-.332\n              2.496 1.433 2.02-.83 1.58-1.18-.141-5.485-2.344-.104.038-1.196.312-2.013 2.95.59 1.542-1.865-1.542-.82\n              1.175-.99-.479-1.912-3.878-.003-1.584v-.01l.812-1.254-1.688-3.042-.007-.1-.106-2.329-2.219-.906-.17-.973-2.688-1.742-1.271.64-.942-1.605-3.225-2.165-.67-.69-1.73-1.834.135-2.981.936-2.624.042-.165.992-2.496.129-2.129.633-.658.107-.788-2.513-1.297-2.574-.67-1.141\n              1.741-1.865-.949-1.18-5.401-.692-1.352-2.514-1.79-1.428-.787-2.195-2.776-1.92-1.516-.936-1.373-1.045-1.541-.093-1.922-.834-1.47-.36-3.286.06-.905.996-2.49m205.291\n              1.867l-3.386-1.667-1.99.033-1.116-.864.627-1.878-1.815-1.232-1.63-.042-.542.178-2.13-2.898-1.138-1.028.64-1-2.72.214-2.43-1.01-1.039\n              1.66-.962-.139-1.444 2.578-2.782.166-2.277-1.342-1.733 3.918-1.5-.522-2.375 3.337-2.637 2.8-1.528-9.591\n              1.157-.204 6.481-1.191 1.709-.312 5.98-1.087.553-.103 3.412-.646 8.782-1.673.152-.02 3.407-.678 3.002-.615\n              2.953-.602 3.048-.649 4.6-.962.05-.01 1.4-.296 4.792-1.036 2.232-2.712h0l.243-.084 2.272.124m10.26\n              23.897l-3.605.79-5.007.952-.505-1.84-.4-1.353-.975-3.52-1.657-5.704-.512-1.878-.251-.92-.374-1.484-1.72-6.268m-158.763-14.05l4.1-.393\n              4.098-.427 2.27-.236 3.803-.384 1.727-.188 5.08-.575 1.281-.145 5.127-.596.388 1.165.367 3.102.28 1.942.344\n              2.902.039.331.584 4.931.148 1.256.43 3.627.344 2.914.486 4.1.095.804.575 5.721.144 1.655.42 3.56.353\n              2.976.05.86.43 4.08.441 3.73.83-.873 2.054 1.121 1.641-.596 2.83 1.051 1.57 2.602.11.874 2.699.734 2.113-.208\n              3.192 2.07h0l.875-.104 1.538-1.428 3.907 1.063-.004-.03 1.597-.186 1.523-2.253.001.01 1.926-.817 1.556 3.28\n              2.277.908 1.252 1.429.36 3.274h0l-.238 2.04 2.814 3.077-.275.296 1.436 1.523 1.5 1.943.77 1.29 2.814 1.8\n              2.277-.07.643.386-.859.67 1.291 2.225 3.05 1.826 2.702.184 2.547-2.894 2.283 1.612 3.375-1.661\n              1.716-1.3-.35-1.514.005.03 1.469.83 3.36-2.651.753 1.005 2.285-2.001-.59-.98 1.36-1.44-1.29-1.016 1.3-3.669\n              1.3-1.74 1.036-2.333.47-2.526 1.255-1.624-.329-.683 1.339-2.647.047-3.072 1.72.502 1.17 1.554 2.453.44\n              1.064-1.443 1.452-5.715.57-1.79 2.075 1.29.75-2.515.907-.496 1.965-3.278.396-.692\n              1.197-1.727-.529-1.705.297-3.991 1.925 1.08 3.17 1.819 3.354 1.912.886-3.803m10.256 5.907l-.404-.435 1.501-.913\n              1.594 1.103-1.21 1.837M241.8 31.106l-1.93 9.01-1.152 5.167-.918 4.289 1.839 4.635 1.12 1.295.002 1.976-1.011.601\n              1.375 1.654-1.87.697 2.284 1.783.624 1.485 1.965.886-.031 1.287 1.22 1.35 1.11 3.284.993.884-.138 1.378 2.987\n              2.913.667 2.089 3.402.17-4.34 11.763.863 2.14-2.72 1.712.688 1.352-1.426 2.621 1.223.108 1.239 2.226 6.086-3.298\n              1.298 1.952-.227 3.724.564 2.854 2.413 4.823-.942 1.44 1.447 3.385 1.341-.469 1.557 2.052.584 3.978-.207 1.414\n              2.2 1.796.829-1.926 4.024.803 1.027.772.638-1.441 1.444-.515 1.814 1.26 3.237-.276.441 1.114 2.806-.306\n              1.451-.015.959-2.603 1.348-.584 1.677 2.726-.271.781 2.087 2.332m470.048 93.837l-.002-.01m27.246 11.017l-3.392\n              1.137m-284.978-6.133l1.541 1.77 2.351.737.656-.624 1.648 1.44-2.462 3.742-.7 1.708 1.97 2.137 1.105 2.419 1.718\n              1.7 2.48.715-.09.863.019 1.306.054 3.717.03 2.046.02 4.923.025 1.67.09 6.2-.046.436.048 6.868.005.365.132\n              5.458-.046.477.078 5.317.015\n              1.084-5.725.071-.955.01-4.983.04-1.697.01-3.87.013-2.651.004h-.53l-7.741-.011-3.34-.033-5.832-.058-4.666-.054-5.036-.087-4.559-.073-3.498-.082-2.915-.096-6.73-.206-6.73-.23-1.218-.044-6.832-.322-1.271-.064-8-.327-4.608-.202-1.8-.074-7.203-.363-6.989-.375-.21-.034m186.99\n              8.787l1.155-2.609 1.26 1.2.945-1.732-.46-1.206 1.076-1.347-.824-.336.926-2.667-.528-.672m-77.981\n              66.442l.075-5.68v-.01l.035-4.692.013-5.987.042-4.168.046-3.855.08-8.38v-.031l-.006-.324-.669-4.534-.36-2.272-.96-6.435-.179-1.142-.95-6.345-.046-3.17-.027-1.863-.064-4.385m.137\n              9.418l8.059-.12 3.148-.067 4.162-.1 4.002-.097.32-.02 6.563-.191 1.227-.041 3.573-.137 5.654-.217.427-.018\n              6.664-.308 3.308-.124.64-.01 4.157-.228 5.064-.28 3.09-.172 5.33-.305.958-.058 1.233 1.76.331 1.866-1.754\n              1.996-2.553 4.028 1.34-.09 4.877-.363 3.803-.298 1.035 1.778-1.782.778.976.9-3.61 1.786 1.53 1.92-1.362.716.717\n              1.05-1.322-.352-.742 1.122.235 2.023-.154.142-.591-1.657-.812.892 1.085.876-1.25 1.74 1.495 1.317-.047\n              1.868-1.35.175-.492 1.763-1.432.665 1.073 1.506-.866 1.035-1.55.6-.934-1.03.272 3.723-1.746 1.073.29 2.182.064\n              2.082-2.692 1.002.284 1.16-1.6 1.95-1.345-.444-.16 2.185.001.01.92 1.723-2.858 1.324 1.148.81-.77 1.164 1.396\n              1.273-2.415.43-1.058 2.076 1.393 1.214-1.465.681.308.602-.248 1.691 1.531 1.662 1.086 3.756-1.612.154 1.077\n              1.39-.619\n              1.022.007.132-1.507.055-2.679.131-.39.02-9.433.37-10.218.276-4.133.076-3.853.097-3.908.108-.502.013-4.411.099-.168.004-3.518.076-.097-4.744-.164-5.27-2.953-.66-2.314.91-1.581-1.752-4.005-1.164-1.837-.765-1.628-2.154-1.271-.048-1.67-1.359-.942-.477-1.423\n              1.598-3.702-.18-.17-.818-3.033 1.123-1.325.639-3.647-.2-1.828 1.856-2.713.477-3.86-2.254.614-.946-.991-.35-1.834\n              1.472-1.49-.407-.975-1.88-.167.11-1.18 1.918-1.05.11.034 1.749-1.656-.263-.185-2.923-2.565\n              1.754-1.268-.23-.417-1.604-1.22.273-1.903-1.66-2.809\n              2.535-1.697-.802.534-1.768-2.089-.378-.767-2.666-.508.524-2.953-.859-.97\n              1.361-.892.371-1.935-1.831-2.273.542-2.92-1.746-3.682-.17-.198-2.303-2.443-2.381-.496\n              1.591-1.081-.454v-.01l-1.52-.471-1.838.678-2.151-2.494-1.26-1.377-1.051.26h0l.092-3.499.226-5.367.12-2.85.19-4.51.156-3.691.207-4.936.139-3.287.299-8.369-8.052-.362-6.13-.307-1.866-.099-7.993-.45-6.073-.383-1.97-.127-12.46-.864m399.628-28.39l.626-.133m.417-.09l.365-.078m-2.138.458l.47-.1m-112.8\n              18.415l3.022-.326 7.141-.893 2.27-.325 3.272-.46 4.64-.697.738-.107 1.427-.189 4.637-1.067 2.642-.349-.354.505\n              4.781-.478 6.675-.807.956-.102 3.321-.508 2.495-.277 5.707-.8.369-.063 4.63-.772 2.945-.503.63-.11 1.837-.335\n              1.838-.327 1.156-.206 4.986-.904.945-.173 4.035-.768 1.934-.393 4.036-.765 2.146-.423 1.934-.395 6.86-1.329\n              1.93-.417 3.615-.69-.03-.148 5.492-1.099.73-.152 2.559-.535 2.766-.584 1.304-.277m-89.487-2.73l-4.303\n              5.167-.048.037-3.246 2.299-.194.14-1.862 1.563-.038 1.631-1.922 1.568.054 1.547-2.743 1.104-.616 2.17-4.6\n              2.14-3.011\n              1.612-3.722.736-1.168.108-3.232.365-.476.059-7.646.714-.106.012-2.831.109-4.471.3-.264.04-2.102.378-5.198.51-2.715.168-3.467.149-3.042.097-2.195.536-2.997.01-4.444.528-.741.09-3.286.335-4.505.466-.795.08-5.586-.305.497\n              3.373-6.442.464-.427.024-4.418.321-.16.002-.106.018-7.613.545-1.059.165-.957.076m-10.557 29.05l8.858-.538\n              1.194-.1 4.348-.267 2.334-.176 2.824-.205 2.93-.239.543-.041 6.134-.48.271-.021 2.442-.2 3.185-.458 5.807-.461\n              5.754-.44.217-.02 5.706-.388.759-.074 7.043-.703.054-.005 6.775-.658 3.905-.352 2.006-.191 1.622-.192 1.512-.201\n              4.323-.538 2.488-.292.54-.074 2.377-.294 4.486-.547-.072-4.13.83-1.245\n              1.983.118.971-.969-.173-2.232.788-1.1.115.047 2.438-2.242 1.643-.357 2.425-.206 3.31-2.954-.053-.392 2.432-1.72\n              1.758-.271.561-3.011 1.179.275.798-1.665 2.14-.977.086 1.368 1.513-.43 1.08-1.934-.004-.02 2.64-1.99\n              2.216.699.743-.478 1.037-2.867.15-.442 1.053-1.284 1.926-.137-.467-.943.182-3.787M198.157 334l3.109-.113\n              1.503-2.708-.358-2.23-2.167-.554-.56-1.192 1.048-2.406-.58-1.65.42-1.811 1.643-.291\n              1.943-1.809.965-2.6.236-4.341 1.887-1.586.273-1.1 2.96-1.08\n              2.243-2.036-2.487-3.316-.992-5.183-1.919-3.524.517-2.321m547.48\n              24.196l-1.36-.981-7.534-5.398-.06-.02-6.724-4.935-.19-.131-3.957-2.647-3.612.57-5.888.86-3.671.545-3.563.528-.081-2.21-1.054-1.06-1.191-1.244-2.001.923-.145-1.954-4.447.402-.592.082-6.06.62-1.566.174-1.46.156-3.678.369-2.083.394-3.21\n              1.34-2.597 1.828-1.962.508-1.599.752-1.44.708m-72.792\n              94.999l-.807-6.471-.565-4.9-.287-2.158-.819-5.963-.56-4.897-.46-3.653.18-6.284.046-1.541.1-5.088.087-6.618.017-1.176.106-5.6.07-4.637.117-4.003.125-5.922.011-.528.131-4.444.053-2.693-.02-2.24.223-5.886-1.735-1.805m148.822\n              1.527l-.25-.138M523.674 419.01l-1.447-2.257 1.141-.97\n              2.065-3.533.145-3.61-1.02-1.574.43-1.358.675-.69-.737-1.912.955-.999 1.824-5.216-.297-2.63\n              1.02-.398-.947-1.234.129-1.655-.739.18-.269-1.594-1.16-.727.186-1.767-2.646-3.493.575-2.19-1.422-2.638-2.207-2.503-.48-4.044-.075-3.68-.116-5.648-.073-3.531-.054-2.594m-133.783-78.468l-.747\n              9.4-.586-.044-.567 8.365-.44 5.937-.165 2.21-.666 8.242-.319 4.299-.289 3.894-.605 8.148-.015.202-.72 8.947-.465\n              4.768-.31 3.42-.71 8.028-.609 8.181-.606 8.146-.122\n              1.638-4.118-.312-6.204-.492-4.06-.336-.676-.057-12.96-1.154-1.07-.1-16.939-1.742-5.964-.621-3.77-.388-.663 1.842\n              1.62 2.341m53.642-169.149l6.65.538 2.701.213 10.107.748.5.035 7.91.528-.303 4.755-.062.97-.309 4.836-.109\n              1.707-.414 6.505-.464 8.077-.007.11-.47 8.19-.104 1.627-.419 6.57-.099 1.557-.415 6.51-.007.122-.576 9.87-.113\n              1.77-.306 4.801-.473\n              7.44-14.115-1.092-1.27-.094-13.589-1-16.846-1.515-1.002-.097-7.28-.738-4.273-.435-6.856-.711-13.89-1.73-.895-.108-13.153-1.64-9.721-1.308L294\n              287.52l-2.688 19.46-.98 7.103-2.171 14.906-1.466 10.607-1.11 8.03-.903 6.536-2.81\n              20.334m383.503-65.37l2.866-.336 1.891-.238 1.026-.13 5.819-.857 1.026-.136 5.591-.905.106 1.18-1.795 1.367-1.267\n              3.273.288.502-.048.058 3.952 2.272.925.7.952.084 1.965.197 1.796 2.945.7 1.433 2.748 3.308.588.998.059.023 4.401\n              2.277 1.336 1.878 2.072 1.535 1.46.775.255.207 1.504 1.053.17 2.272 1.59 1.6 1.624.685.004.776 2.437.815\n              1.299.74 2.427 3.64.534 1.623.653 2.748 1.775.449.001.01 1.722 1.548 1.308 2.152.043 2.086.765\n              1.952m-75.922-44.23l.636 2.292 1.194 4.356.182.641.35 1.172 1.259 4.378 1.084 3.764.573 2.143.295 1.147 1.293\n              4.573.854 3.116.281 1.005 1.518 5.478.1.395 1.285 4.355.987 2.223 1.19 2.484 1.438 1.681.736 2.423-.453.987\n              1.987.976-.486.697-1.921 2.05.208 1.305-.014 1.362-.8 1.949.127 2.105.264.314 1.372 2.479.398 1.951-.175\n              3.954.087 2.746 1.323 1.488.561\n              1.353-7.677.933-.17.02-8.479.987-2.45.245-3.192.328-4.733.452-1.543.11-6.048.546-6.9.658-.355 2.496 1.867 2.197\n              2.114 1.042-.138 3.586m37.704-13.6l2.85 5.106 7.755-.518 1.552-.1 3.16-.223 1.264-.089 4.197-.285 2.127-.145\n              4.084-.277.23-.011.52-.019 2.762-.19 7.194-.5 1.67-.115 2.013-.155.634-.04 3.284-.223.632 3.128\n              2.552.296.134-3.82-.93-1.57.03-2.546 1.763-1.025 5.023 1.337M563.851 355.42l-.069 1.954 1.263-1.571.517\n              1.328-1.211 1.507.03 1.696 1.36.223-1.319 1.675 1.745 1.132-.38.272-.655 1.469 2.41.864-.557 1.17\n              1.495.547-.971.84-.126 1.884-2.098-.133-.545 1.502 1.756.061.286.046.006.12-.583 1.858-1.698 1.127-.875\n              1.77-1.455.404.49 1.893-.949.339-.236 2.16-1.87.18 1.75.864-1.674.736.13 1.536-.988.843 1.083 2.388-2.146.564\n              1.078 1.058-.563 1.427 1.072.887-1.086 1.31 7.324-.334 1.888-.098 3.717-.218 4.06-.226.344-.02 3.201-.197\n              1.373-.083 6.8-.456 1.716-.113-1.423 6.384 1.332 2.734 1.336.98.963 3.158 2.098 1.893m12.756-218.607h0l.404\n              4.51.282 3.162.22 2.468.263 2.931.457 5.119.413 4.616.023.262.502 6.184.393 4.975.514 5.18.218 2.44.218\n              2.43-.877 1.746-.189 1.948-.205.019 1.2 1.866.868 2.77.001.01.032.932.33 3.123-1.61 2.38.204 1.131-1.4.692.154\n              1.177-2.981 3.621-.343-.347.145.486 1.15 1.203-1.255 2.516.178 2.74-1.152.046.053.016 1.032 1.641M537.473\n              99.632l-1.156-.014h0l.18 4.587.188 4.83-.642 2.68-4.582 2.393-1.624 3.164-.51 1.612.042 1.253 1.46.122 1.668\n              2.04-1.12 3.02-.085 1.621.032 6.5-.355 2.165.971.58 2.426 2.62 3.21.423.97 1.583 2.18.778.049.008 2.159\n              1.298.974 2.587 4.166 2.955 1.813.69 1.999 2.473.496 2.215.002.04-.091 2.052.833 2.138m147.965 12.904l.39 2.373\n              1.069 6.503.03.19 1.088 6.615.026.16.687 4.181.196.88.6 3.962-1.87 1.382 1.306 1.735-.19 1.652.657 1.513-.772\n              2.515-.215.578-.028 2.364.069 2.337-.77 1.303.233 2.414-1.227 2.36-1.115 1.46-.923 1.704-1.073 1.43-2.138\n              1.286-1.05-1.077-1.578 1.554.004 1.383-1.543.112-.502 1.151-.307.723.338 1.547.237 3.293-1.922\n              1.118v-1.045l-1.744-1.552-1.195 1.446-.245 2.237-.941 1.07 1.136 3.467-.575.37-1.002.32-.195 2.64-2.483\n              1.001-1.313.003m145.315-92.765l-1.504-.823-1.87-3.57-1.685-.183-4.023 1.232m-576.952 18.959l-3.529 18.366-3.239\n              16.317-.749 3.897-1.291 6.722-3.082 16.032-.422 1.92-1.46 7.868-1.986 10.057-2.152 11.191m361.03 31.453l.155\n              3.045-.981.564 1.246.97-2.402.193 1.048 1.219.606 1.024-1.23.905-.272 1.58");
			attr(path0, "class", "svelte-6mapeg");
			attr(g2, "style", g2_style_value = `stroke-width:${1.5 / /*$zoom*/ ctx[36]}px`);
			attr(g2, "transform", g2_transform_value = `translate(${/*width*/ ctx[5] / 2},${/*height*/ ctx[4] / 2}) scale(${/*$zoom*/ ctx[36]}) translate(${-/*$coords*/ ctx[37].x},${-/*$coords*/ ctx[37].y})`);
			attr(path1, "d", "M-1,1 l4,-4\n                     M0,8 l8,-8\n                     M3,5 l4,-4");
			set_style(path1, "stroke", "gray");
			set_style(path1, "stroke-width", "1");
			attr(pattern, "id", "diagonalHatch");
			attr(pattern, "patternUnits", "userSpaceOnUse");
			attr(pattern, "width", "8");
			attr(pattern, "height", "8");
			set_style(pattern, "position", "absolute");
			set_style(pattern, "opacity", "0");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			attr(svg, "width", "100%");
			attr(svg, "height", "100%");
			attr(svg, "viewBox", svg_viewBox_value = `0 0 ${/*width*/ ctx[5]} ${/*height*/ ctx[4]}`);
			attr(svg, "class", "svelte-6mapeg");
			attr(div1, "class", div1_class_value = "" + (null_to_empty(`nh-map ${/*classes*/ ctx[3]}`) + " svelte-6mapeg"));
		},
		m(target, anchor) {
			insert_hydration(target, div1, anchor);
			if (if_block0) if_block0.m(div1, null);
			append_hydration(div1, t0);
			if (if_block1) if_block1.m(div1, null);
			append_hydration(div1, t1);
			append_hydration(div1, div0);
			append_hydration(div0, svg);
			append_hydration(svg, rect);
			append_hydration(svg, g2);
			append_hydration(g2, g0);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(g0, null);
			}

			append_hydration(g2, g1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(g1, null);
			}

			append_hydration(g2, path0);
			append_hydration(svg, pattern);
			append_hydration(pattern, path1);
			append_hydration(div1, t2);
			if (if_block2) if_block2.m(div1, null);
			current = true;

			if (!mounted) {
				dispose = [
					listen(rect, "click", /*resetZoom*/ ctx[50]),
					listen(div0, "mousemove", /*positionHover*/ ctx[54]),
					listen(div0, "mouseleave", /*mouseleave_handler*/ ctx[67])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (/*hoveredEntity*/ ctx[29]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_13(ctx);
					if_block0.c();
					if_block0.m(div1, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*selected*/ ctx[10]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*selected*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_12(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div1, t1);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (!current || dirty[0] & /*width*/ 32) {
				attr(rect, "width", /*width*/ ctx[5]);
			}

			if (!current || dirty[0] & /*height*/ 16) {
				attr(rect, "height", /*height*/ ctx[4]);
			}

			if (dirty[1] & /*counties, getCountyOutageColorClass, handleEntityHover, isDev*/ 4227208) {
				each_value_3 = /*counties*/ ctx[34];
				each_blocks_1 = update_keyed_each(each_blocks_1, dirty, get_key, 1, ctx, each_value_3, each0_lookup, g0, destroy_block, create_each_block_3, null, get_each_context_3);
			}

			if (dirty[0] & /*states, selected, disableStateZoom, sliderValue*/ 3137 | dirty[1] & /*getStateOutageColorClass, updateZoom, handleStateClick, ensureStateData, handleEntityHover*/ 7421952) {
				each_value_2 = /*states*/ ctx[0];
				let i;

				for (i = 0; i < each_value_2.length; i += 1) {
					const child_ctx = get_each_context_2(ctx, each_value_2, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_2(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(g1, null);
					}
				}

				group_outros();

				for (i = each_value_2.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (!current || dirty[0] & /*mapStrokeColor*/ 512 && path0_style_value !== (path0_style_value = /*mapStrokeColor*/ ctx[9]
			? `stroke: ${/*mapStrokeColor*/ ctx[9]};`
			: '')) {
				attr(path0, "style", path0_style_value);
			}

			if (!current || dirty[1] & /*$zoom*/ 32 && g2_style_value !== (g2_style_value = `stroke-width:${1.5 / /*$zoom*/ ctx[36]}px`)) {
				attr(g2, "style", g2_style_value);
			}

			if (!current || dirty[0] & /*width, height*/ 48 | dirty[1] & /*$zoom, $coords*/ 96 && g2_transform_value !== (g2_transform_value = `translate(${/*width*/ ctx[5] / 2},${/*height*/ ctx[4] / 2}) scale(${/*$zoom*/ ctx[36]}) translate(${-/*$coords*/ ctx[37].x},${-/*$coords*/ ctx[37].y})`)) {
				attr(g2, "transform", g2_transform_value);
			}

			if (!current || dirty[0] & /*width, height*/ 48 && svg_viewBox_value !== (svg_viewBox_value = `0 0 ${/*width*/ ctx[5]} ${/*height*/ ctx[4]}`)) {
				attr(svg, "viewBox", svg_viewBox_value);
			}

			if (/*nationalInfo*/ ctx[28]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_10(ctx);
					if_block2.c();
					if_block2.m(div1, null);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (!current || dirty[0] & /*classes*/ 8 && div1_class_value !== (div1_class_value = "" + (null_to_empty(`nh-map ${/*classes*/ ctx[3]}`) + " svelte-6mapeg"))) {
				attr(div1, "class", div1_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block1);

			for (let i = 0; i < each_value_2.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			transition_out(if_block1);
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].d();
			}

			destroy_each(each_blocks, detaching);
			if (if_block2) if_block2.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

// (778:6) {#if hoveredEntity}
function create_if_block_13(ctx) {
	let div4;
	let div3;
	let div0;
	let t0;
	let t1;
	let div2;
	let div1;
	let t2_value = /*hoveredEntity*/ ctx[29].outageCustomers + "";
	let t2;
	let t3;
	let div4_style_value;
	let if_block0 = /*hoveredEntity*/ ctx[29].stateName && create_if_block_15(ctx);
	let if_block1 = /*hoveredEntity*/ ctx[29].countyName && create_if_block_14(ctx);

	return {
		c() {
			div4 = element("div");
			div3 = element("div");
			div0 = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			div2 = element("div");
			div1 = element("div");
			t2 = text(t2_value);
			t3 = text(" Customers Out");
			this.h();
		},
		l(nodes) {
			div4 = claim_element(nodes, "DIV", { style: true, class: true });
			var div4_nodes = children(div4);
			div3 = claim_element(div4_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			div0 = claim_element(div3_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			if (if_block0) if_block0.l(div0_nodes);
			t0 = claim_space(div0_nodes);
			if (if_block1) if_block1.l(div0_nodes);
			div0_nodes.forEach(detach);
			t1 = claim_space(div3_nodes);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			t2 = claim_text(div1_nodes, t2_value);
			t3 = claim_text(div1_nodes, " Customers Out");
			div1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			div4_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div0, "class", "overall-score-description align-self-center mb-1 text-center text-body svelte-6mapeg");
			attr(div1, "class", "overall-score-count svelte-6mapeg");
			attr(div2, "class", "border-top pt-2");
			attr(div3, "class", "row overall-score justify-content-around pb-2 mx-1 flex-column");
			attr(div4, "style", div4_style_value = `position:absolute; top:${/*hoverY*/ ctx[31] + 18}px; left:${/*hoverX*/ ctx[30] - 160}px;`);
			attr(div4, "class", "tiny-report-card d-flex flex-column bg-white border p-1 rounded shadow svelte-6mapeg");
		},
		m(target, anchor) {
			insert_hydration(target, div4, anchor);
			append_hydration(div4, div3);
			append_hydration(div3, div0);
			if (if_block0) if_block0.m(div0, null);
			append_hydration(div0, t0);
			if (if_block1) if_block1.m(div0, null);
			append_hydration(div3, t1);
			append_hydration(div3, div2);
			append_hydration(div2, div1);
			append_hydration(div1, t2);
			append_hydration(div1, t3);
		},
		p(ctx, dirty) {
			if (/*hoveredEntity*/ ctx[29].stateName) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_15(ctx);
					if_block0.c();
					if_block0.m(div0, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*hoveredEntity*/ ctx[29].countyName) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_14(ctx);
					if_block1.c();
					if_block1.m(div0, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty[0] & /*hoveredEntity*/ 536870912 && t2_value !== (t2_value = /*hoveredEntity*/ ctx[29].outageCustomers + "")) set_data(t2, t2_value);

			if (dirty[0] & /*hoverX*/ 1073741824 | dirty[1] & /*hoverY*/ 1 && div4_style_value !== (div4_style_value = `position:absolute; top:${/*hoverY*/ ctx[31] + 18}px; left:${/*hoverX*/ ctx[30] - 160}px;`)) {
				attr(div4, "style", div4_style_value);
			}
		},
		d(detaching) {
			if (detaching) detach(div4);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
		}
	};
}

// (785:14) {#if hoveredEntity.stateName}
function create_if_block_15(ctx) {
	let t_value = /*hoveredEntity*/ ctx[29].stateName + "";
	let t;

	return {
		c() {
			t = text(t_value);
		},
		l(nodes) {
			t = claim_text(nodes, t_value);
		},
		m(target, anchor) {
			insert_hydration(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*hoveredEntity*/ 536870912 && t_value !== (t_value = /*hoveredEntity*/ ctx[29].stateName + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (788:14) {#if hoveredEntity.countyName}
function create_if_block_14(ctx) {
	let t_value = /*hoveredEntity*/ ctx[29].countyName + "";
	let t;

	return {
		c() {
			t = text(t_value);
		},
		l(nodes) {
			t = claim_text(nodes, t_value);
		},
		m(target, anchor) {
			insert_hydration(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*hoveredEntity*/ 536870912 && t_value !== (t_value = /*hoveredEntity*/ ctx[29].countyName + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (798:6) {#if selected}
function create_if_block_12(ctx) {
	let div;
	let icon;
	let t;
	let current;
	let mounted;
	let dispose;
	icon = new Icon({ props: { icon: "compress" } });

	return {
		c() {
			div = element("div");
			create_component(icon.$$.fragment);
			t = text("\n          Zoom Out");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(icon.$$.fragment, div_nodes);
			t = claim_text(div_nodes, "\n          Zoom Out");
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "zoom-out svelte-6mapeg");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			mount_component(icon, div, null);
			append_hydration(div, t);
			current = true;

			if (!mounted) {
				dispose = listen(div, "click", /*click_handler*/ ctx[61]);
				mounted = true;
			}
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(icon);
			mounted = false;
			dispose();
		}
	};
}

// (813:14) {#each counties as county, i (county)}
function create_each_block_3(key_1, ctx) {
	let path;
	let path_d_value;
	let path_class_value;
	let mounted;
	let dispose;

	function mouseover_handler(...args) {
		return /*mouseover_handler*/ ctx[62](/*county*/ ctx[102], ...args);
	}

	function click_handler_1() {
		return /*click_handler_1*/ ctx[63](/*county*/ ctx[102]);
	}

	return {
		key: key_1,
		first: null,
		c() {
			path = svg_element("path");
			this.h();
		},
		l(nodes) {
			path = claim_svg_element(nodes, "path", { d: true, class: true });
			children(path).forEach(detach);
			this.h();
		},
		h() {
			attr(path, "d", path_d_value = /*county*/ ctx[102].svgPath);
			attr(path, "class", path_class_value = "" + (null_to_empty(`${/*getCountyOutageColorClass*/ ctx[46](/*county*/ ctx[102].outageCustomers, /*county*/ ctx[102].servedCustomers)}`) + " svelte-6mapeg"));
			this.first = path;
		},
		m(target, anchor) {
			insert_hydration(target, path, anchor);

			if (!mounted) {
				dispose = [
					listen(path, "mouseover", mouseover_handler),
					listen(path, "focus", null),
					listen(path, "click", click_handler_1)
				];

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[1] & /*counties*/ 8 && path_d_value !== (path_d_value = /*county*/ ctx[102].svgPath)) {
				attr(path, "d", path_d_value);
			}

			if (dirty[1] & /*counties*/ 8 && path_class_value !== (path_class_value = "" + (null_to_empty(`${/*getCountyOutageColorClass*/ ctx[46](/*county*/ ctx[102].outageCustomers, /*county*/ ctx[102].servedCustomers)}`) + " svelte-6mapeg"))) {
				attr(path, "class", path_class_value);
			}
		},
		d(detaching) {
			if (detaching) detach(path);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (839:16) {:else}
function create_else_block_3(ctx) {
	let statepath;
	let current;

	function clicked_handler_1(...args) {
		return /*clicked_handler_1*/ ctx[65](/*state*/ ctx[99], ...args);
	}

	function hovered_handler(...args) {
		return /*hovered_handler*/ ctx[66](/*state*/ ctx[99], ...args);
	}

	statepath = new StatePath({
			props: {
				state: /*state*/ ctx[99],
				classes: `${/*getStateOutageColorClass*/ ctx[45](/*state*/ ctx[99].outageCustomers)}`
			}
		});

	statepath.$on("clicked", clicked_handler_1);
	statepath.$on("hovered", hovered_handler);

	return {
		c() {
			create_component(statepath.$$.fragment);
		},
		l(nodes) {
			claim_component(statepath.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(statepath, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const statepath_changes = {};
			if (dirty[0] & /*states*/ 1) statepath_changes.state = /*state*/ ctx[99];
			if (dirty[0] & /*states*/ 1) statepath_changes.classes = `${/*getStateOutageColorClass*/ ctx[45](/*state*/ ctx[99].outageCustomers)}`;
			statepath.$set(statepath_changes);
		},
		i(local) {
			if (current) return;
			transition_in(statepath.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(statepath.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(statepath, detaching);
		}
	};
}

// (829:16) {#if state.slug === selected}
function create_if_block_11(ctx) {
	let statepath;
	let current;

	function clicked_handler(...args) {
		return /*clicked_handler*/ ctx[64](/*state*/ ctx[99], ...args);
	}

	statepath = new StatePath({
			props: {
				selected: "true",
				state: /*state*/ ctx[99],
				classes: `${/*getStateOutageColorClass*/ ctx[45](/*state*/ ctx[99].outageCustomers)} ${' bb-set'} active`
			}
		});

	statepath.$on("updateZoom", /*updateZoom*/ ctx[51]);
	statepath.$on("clicked", clicked_handler);

	return {
		c() {
			create_component(statepath.$$.fragment);
		},
		l(nodes) {
			claim_component(statepath.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(statepath, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const statepath_changes = {};
			if (dirty[0] & /*states*/ 1) statepath_changes.state = /*state*/ ctx[99];
			if (dirty[0] & /*states*/ 1) statepath_changes.classes = `${/*getStateOutageColorClass*/ ctx[45](/*state*/ ctx[99].outageCustomers)} ${' bb-set'} active`;
			statepath.$set(statepath_changes);
		},
		i(local) {
			if (current) return;
			transition_in(statepath.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(statepath.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(statepath, detaching);
		}
	};
}

// (828:14) {#each states as state}
function create_each_block_2(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_11, create_else_block_3];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*state*/ ctx[99].slug === /*selected*/ ctx[10]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, [-1, -1, -1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (1044:6) {#if nationalInfo}
function create_if_block_10(ctx) {
	let div;
	let span;
	let t0;
	let t1;
	let strong;
	let t2;

	return {
		c() {
			div = element("div");
			span = element("span");
			t0 = text("Customers Out:");
			t1 = space();
			strong = element("strong");
			t2 = text(/*nationalInfo*/ ctx[28]);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			span = claim_element(div_nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t0 = claim_text(span_nodes, "Customers Out:");
			span_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			strong = claim_element(div_nodes, "STRONG", {});
			var strong_nodes = children(strong);
			t2 = claim_text(strong_nodes, /*nationalInfo*/ ctx[28]);
			strong_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "svelte-6mapeg");
			attr(div, "class", "average-data svelte-6mapeg");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, span);
			append_hydration(span, t0);
			append_hydration(div, t1);
			append_hydration(div, strong);
			append_hydration(strong, t2);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*nationalInfo*/ 268435456) set_data(t2, /*nationalInfo*/ ctx[28]);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (1066:6) {#each tickHours as hour}
function create_each_block_1(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true, style: true });
			children(div).forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "tick svelte-6mapeg");
			set_style(div, "left", /*hour*/ ctx[94] / 71 * 100 + "%");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (1073:6) {#each tickHours as hour}
function create_each_block(ctx) {
	let div;
	let t0_value = /*getLabel*/ ctx[41](/*hour*/ ctx[94]) + "";
	let t0;
	let t1;

	return {
		c() {
			div = element("div");
			t0 = text(t0_value);
			t1 = space();
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true, style: true });
			var div_nodes = children(div);
			t0 = claim_text(div_nodes, t0_value);
			t1 = claim_space(div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "label svelte-6mapeg");
			set_style(div, "left", /*hour*/ ctx[94] / 71 * 100 + "%");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t0);
			append_hydration(div, t1);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (1081:2) {#if pageType !== 'all'}
function create_if_block_3(ctx) {
	let section;
	let h2;
	let t0;
	let t1;
	let div3;
	let div0;
	let p0;
	let t2;
	let t3;
	let p1;

	let t4_value = (/*peakCustomersOut*/ ctx[24] !== null && /*peakCustomersOut*/ ctx[24] !== undefined
	? /*peakCustomersOut*/ ctx[24].toLocaleString()
	: 'Loading') + "";

	let t4;
	let t5;
	let div1;
	let p2;
	let t6;
	let t7;
	let p3;

	let t8_value = (/*averageCustomersOut*/ ctx[25] !== null && /*averageCustomersOut*/ ctx[25] !== undefined
	? /*averageCustomersOut*/ ctx[25].toLocaleString()
	: 'Loading') + "";

	let t8;
	let t9;
	let div2;
	let p4;
	let t10;
	let t11;
	let p5;
	let t12;

	function select_block_type_1(ctx, dirty) {
		if (/*customerOutChange*/ ctx[26] === null || /*customerOutChange*/ ctx[26] === undefined) return create_if_block_7;
		if (/*customerOutChange*/ ctx[26] < 0) return create_if_block_8;
		return create_else_block_2;
	}

	let current_block_type = select_block_type_1(ctx, [-1, -1, -1, -1]);
	let if_block0 = current_block_type(ctx);
	let if_block1 = /*pageType*/ ctx[2] === 'state' && create_if_block_4(ctx);

	return {
		c() {
			section = element("section");
			h2 = element("h2");
			t0 = text("In the Past 72 Hours");
			t1 = space();
			div3 = element("div");
			div0 = element("div");
			p0 = element("p");
			t2 = text("Peak Customers Out:");
			t3 = space();
			p1 = element("p");
			t4 = text(t4_value);
			t5 = space();
			div1 = element("div");
			p2 = element("p");
			t6 = text("Average Customers Out:");
			t7 = space();
			p3 = element("p");
			t8 = text(t8_value);
			t9 = space();
			div2 = element("div");
			p4 = element("p");
			t10 = text("Customers Out Change:");
			t11 = space();
			p5 = element("p");
			if_block0.c();
			t12 = space();
			if (if_block1) if_block1.c();
			this.h();
		},
		l(nodes) {
			section = claim_element(nodes, "SECTION", { class: true });
			var section_nodes = children(section);
			h2 = claim_element(section_nodes, "H2", {});
			var h2_nodes = children(h2);
			t0 = claim_text(h2_nodes, "In the Past 72 Hours");
			h2_nodes.forEach(detach);
			t1 = claim_space(section_nodes);
			div3 = claim_element(section_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			div0 = claim_element(div3_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			p0 = claim_element(div0_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t2 = claim_text(p0_nodes, "Peak Customers Out:");
			p0_nodes.forEach(detach);
			t3 = claim_space(div0_nodes);
			p1 = claim_element(div0_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t4 = claim_text(p1_nodes, t4_value);
			p1_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t5 = claim_space(div3_nodes);
			div1 = claim_element(div3_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			p2 = claim_element(div1_nodes, "P", { class: true });
			var p2_nodes = children(p2);
			t6 = claim_text(p2_nodes, "Average Customers Out:");
			p2_nodes.forEach(detach);
			t7 = claim_space(div1_nodes);
			p3 = claim_element(div1_nodes, "P", { class: true });
			var p3_nodes = children(p3);
			t8 = claim_text(p3_nodes, t8_value);
			p3_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			t9 = claim_space(div3_nodes);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			p4 = claim_element(div2_nodes, "P", { class: true });
			var p4_nodes = children(p4);
			t10 = claim_text(p4_nodes, "Customers Out Change:");
			p4_nodes.forEach(detach);
			t11 = claim_space(div2_nodes);
			p5 = claim_element(div2_nodes, "P", { class: true });
			var p5_nodes = children(p5);
			if_block0.l(p5_nodes);
			p5_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			t12 = claim_space(section_nodes);
			if (if_block1) if_block1.l(section_nodes);
			section_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p0, "class", "card-grid__title");
			attr(p1, "class", "card-grid__data");
			attr(div0, "class", "card-grid__item");
			attr(p2, "class", "card-grid__title");
			attr(p3, "class", "card-grid__data");
			attr(div1, "class", "card-grid__item");
			attr(p4, "class", "card-grid__title");
			attr(p5, "class", "card-grid__data");
			attr(div2, "class", "card-grid__item");
			attr(div3, "class", "card-grid");
			attr(section, "class", "section-gap");
		},
		m(target, anchor) {
			insert_hydration(target, section, anchor);
			append_hydration(section, h2);
			append_hydration(h2, t0);
			append_hydration(section, t1);
			append_hydration(section, div3);
			append_hydration(div3, div0);
			append_hydration(div0, p0);
			append_hydration(p0, t2);
			append_hydration(div0, t3);
			append_hydration(div0, p1);
			append_hydration(p1, t4);
			append_hydration(div3, t5);
			append_hydration(div3, div1);
			append_hydration(div1, p2);
			append_hydration(p2, t6);
			append_hydration(div1, t7);
			append_hydration(div1, p3);
			append_hydration(p3, t8);
			append_hydration(div3, t9);
			append_hydration(div3, div2);
			append_hydration(div2, p4);
			append_hydration(p4, t10);
			append_hydration(div2, t11);
			append_hydration(div2, p5);
			if_block0.m(p5, null);
			append_hydration(section, t12);
			if (if_block1) if_block1.m(section, null);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*peakCustomersOut*/ 16777216 && t4_value !== (t4_value = (/*peakCustomersOut*/ ctx[24] !== null && /*peakCustomersOut*/ ctx[24] !== undefined
			? /*peakCustomersOut*/ ctx[24].toLocaleString()
			: 'Loading') + "")) set_data(t4, t4_value);

			if (dirty[0] & /*averageCustomersOut*/ 33554432 && t8_value !== (t8_value = (/*averageCustomersOut*/ ctx[25] !== null && /*averageCustomersOut*/ ctx[25] !== undefined
			? /*averageCustomersOut*/ ctx[25].toLocaleString()
			: 'Loading') + "")) set_data(t8, t8_value);

			if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block0) {
				if_block0.p(ctx, dirty);
			} else {
				if_block0.d(1);
				if_block0 = current_block_type(ctx);

				if (if_block0) {
					if_block0.c();
					if_block0.m(p5, null);
				}
			}

			if (/*pageType*/ ctx[2] === 'state') {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_4(ctx);
					if_block1.c();
					if_block1.m(section, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}
		},
		d(detaching) {
			if (detaching) detach(section);
			if_block0.d();
			if (if_block1) if_block1.d();
		}
	};
}

// (1110:12) {:else}
function create_else_block_2(ctx) {
	let t0_value = /*customerOutChange*/ ctx[26].toLocaleString() + "";
	let t0;
	let t1;

	return {
		c() {
			t0 = text(t0_value);
			t1 = text(" restored");
		},
		l(nodes) {
			t0 = claim_text(nodes, t0_value);
			t1 = claim_text(nodes, " restored");
		},
		m(target, anchor) {
			insert_hydration(target, t0, anchor);
			insert_hydration(target, t1, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*customerOutChange*/ 67108864 && t0_value !== (t0_value = /*customerOutChange*/ ctx[26].toLocaleString() + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
		}
	};
}

// (1108:44) 
function create_if_block_8(ctx) {
	let t0_value = Math.abs(/*customerOutChange*/ ctx[26]).toLocaleString() + "";
	let t0;
	let t1;

	return {
		c() {
			t0 = text(t0_value);
			t1 = text(" lost");
		},
		l(nodes) {
			t0 = claim_text(nodes, t0_value);
			t1 = claim_text(nodes, " lost");
		},
		m(target, anchor) {
			insert_hydration(target, t0, anchor);
			insert_hydration(target, t1, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*customerOutChange*/ 67108864 && t0_value !== (t0_value = Math.abs(/*customerOutChange*/ ctx[26]).toLocaleString() + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
		}
	};
}

// (1106:12) {#if customerOutChange === null || customerOutChange === undefined}
function create_if_block_7(ctx) {
	let t;

	return {
		c() {
			t = text("Loading");
		},
		l(nodes) {
			t = claim_text(nodes, "Loading");
		},
		m(target, anchor) {
			insert_hydration(target, t, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (1117:6) {#if pageType === 'state'}
function create_if_block_4(ctx) {
	let br;
	let t0;
	let p;
	let t1;
	let t2_value = /*currentState*/ ctx[8].name + "";
	let t2;
	let t3;

	let t4_value = (/*peakCustomersOut*/ ctx[24] !== null && /*peakCustomersOut*/ ctx[24] !== undefined
	? /*peakCustomersOut*/ ctx[24].toLocaleString()
	: '') + "";

	let t4;
	let t5;

	let t6_value = (/*peakCustomersOutPercentage*/ ctx[27] !== null && /*peakCustomersOutPercentage*/ ctx[27] !== undefined
	? /*peakCustomersOutPercentage*/ ctx[27]
	: '') + "";

	let t6;
	let t7;

	let t8_value = (/*averageCustomersOut*/ ctx[25] !== null && /*averageCustomersOut*/ ctx[25] !== undefined
	? /*averageCustomersOut*/ ctx[25].toLocaleString()
	: '') + "";

	let t8;
	let t9;

	function select_block_type_2(ctx, dirty) {
		if (/*customerOutChange*/ ctx[26] === null || /*customerOutChange*/ ctx[26] === undefined) return create_if_block_5;
		if (/*customerOutChange*/ ctx[26] < 0) return create_if_block_6;
		return create_else_block_1;
	}

	let current_block_type = select_block_type_2(ctx, [-1, -1, -1, -1]);
	let if_block = current_block_type(ctx);

	return {
		c() {
			br = element("br");
			t0 = space();
			p = element("p");
			t1 = text("In the past 72 hours, ");
			t2 = text(t2_value);
			t3 = text(" has had a peak outage count of\n          ");
			t4 = text(t4_value);
			t5 = text("\n          and a peak percentage of customers out of\n          ");
			t6 = text(t6_value);
			t7 = text("%. The average number of customers out in the state over the last 72 hours is\n          ");
			t8 = text(t8_value);
			t9 = text(". The trend for outages in the state over the last 72 hours is net\n          ");
			if_block.c();
		},
		l(nodes) {
			br = claim_element(nodes, "BR", {});
			t0 = claim_space(nodes);
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t1 = claim_text(p_nodes, "In the past 72 hours, ");
			t2 = claim_text(p_nodes, t2_value);
			t3 = claim_text(p_nodes, " has had a peak outage count of\n          ");
			t4 = claim_text(p_nodes, t4_value);
			t5 = claim_text(p_nodes, "\n          and a peak percentage of customers out of\n          ");
			t6 = claim_text(p_nodes, t6_value);
			t7 = claim_text(p_nodes, "%. The average number of customers out in the state over the last 72 hours is\n          ");
			t8 = claim_text(p_nodes, t8_value);
			t9 = claim_text(p_nodes, ". The trend for outages in the state over the last 72 hours is net\n          ");
			if_block.l(p_nodes);
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert_hydration(target, br, anchor);
			insert_hydration(target, t0, anchor);
			insert_hydration(target, p, anchor);
			append_hydration(p, t1);
			append_hydration(p, t2);
			append_hydration(p, t3);
			append_hydration(p, t4);
			append_hydration(p, t5);
			append_hydration(p, t6);
			append_hydration(p, t7);
			append_hydration(p, t8);
			append_hydration(p, t9);
			if_block.m(p, null);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*currentState*/ 256 && t2_value !== (t2_value = /*currentState*/ ctx[8].name + "")) set_data(t2, t2_value);

			if (dirty[0] & /*peakCustomersOut*/ 16777216 && t4_value !== (t4_value = (/*peakCustomersOut*/ ctx[24] !== null && /*peakCustomersOut*/ ctx[24] !== undefined
			? /*peakCustomersOut*/ ctx[24].toLocaleString()
			: '') + "")) set_data(t4, t4_value);

			if (dirty[0] & /*peakCustomersOutPercentage*/ 134217728 && t6_value !== (t6_value = (/*peakCustomersOutPercentage*/ ctx[27] !== null && /*peakCustomersOutPercentage*/ ctx[27] !== undefined
			? /*peakCustomersOutPercentage*/ ctx[27]
			: '') + "")) set_data(t6, t6_value);

			if (dirty[0] & /*averageCustomersOut*/ 33554432 && t8_value !== (t8_value = (/*averageCustomersOut*/ ctx[25] !== null && /*averageCustomersOut*/ ctx[25] !== undefined
			? /*averageCustomersOut*/ ctx[25].toLocaleString()
			: '') + "")) set_data(t8, t8_value);

			if (current_block_type === (current_block_type = select_block_type_2(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(p, null);
				}
			}
		},
		d(detaching) {
			if (detaching) detach(br);
			if (detaching) detach(t0);
			if (detaching) detach(p);
			if_block.d();
		}
	};
}

// (1133:10) {:else}
function create_else_block_1(ctx) {
	let t0_value = /*customerOutChange*/ ctx[26].toLocaleString() + "";
	let t0;
	let t1;

	return {
		c() {
			t0 = text(t0_value);
			t1 = text(" customers had power restored.");
		},
		l(nodes) {
			t0 = claim_text(nodes, t0_value);
			t1 = claim_text(nodes, " customers had power restored.");
		},
		m(target, anchor) {
			insert_hydration(target, t0, anchor);
			insert_hydration(target, t1, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*customerOutChange*/ 67108864 && t0_value !== (t0_value = /*customerOutChange*/ ctx[26].toLocaleString() + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
		}
	};
}

// (1131:42) 
function create_if_block_6(ctx) {
	let t0_value = Math.abs(/*customerOutChange*/ ctx[26]).toLocaleString() + "";
	let t0;
	let t1;

	return {
		c() {
			t0 = text(t0_value);
			t1 = text(" customers lost power.");
		},
		l(nodes) {
			t0 = claim_text(nodes, t0_value);
			t1 = claim_text(nodes, " customers lost power.");
		},
		m(target, anchor) {
			insert_hydration(target, t0, anchor);
			insert_hydration(target, t1, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*customerOutChange*/ 67108864 && t0_value !== (t0_value = Math.abs(/*customerOutChange*/ ctx[26]).toLocaleString() + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
		}
	};
}

// (1129:10) {#if customerOutChange === null || customerOutChange === undefined}
function create_if_block_5(ctx) {
	let t;

	return {
		c() {
			t = text("Loading");
		},
		l(nodes) {
			t = claim_text(nodes, "Loading");
		},
		m(target, anchor) {
			insert_hydration(target, t, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (1164:6) {:else}
function create_else_block(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("This table contains the customers without power for every state in the USA.");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "This table contains the customers without power for every state in the USA.");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert_hydration(target, p, anchor);
			append_hydration(p, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (1159:6) {#if pageType === 'state'}
function create_if_block_2(ctx) {
	let p;
	let t0;
	let t1_value = /*currentState*/ ctx[8].name + "";
	let t1;
	let t2;

	return {
		c() {
			p = element("p");
			t0 = text("This table contains the customers out, total customers served, and when the data was last updated for every\n          utility in ");
			t1 = text(t1_value);
			t2 = text(".");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t0 = claim_text(p_nodes, "This table contains the customers out, total customers served, and when the data was last updated for every\n          utility in ");
			t1 = claim_text(p_nodes, t1_value);
			t2 = claim_text(p_nodes, ".");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert_hydration(target, p, anchor);
			append_hydration(p, t0);
			append_hydration(p, t1);
			append_hydration(p, t2);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*currentState*/ 256 && t1_value !== (t1_value = /*currentState*/ ctx[8].name + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (1167:6) {#if pageType === 'all'}
function create_if_block_1(ctx) {
	let sortabletable;
	let current;

	sortabletable = new SortableTable({
			props: {
				items: /*states*/ ctx[0],
				pageSize: 10,
				sortBy: 'outageCustomers',
				columns: /*OUTAGE_TABLE_COLUMNS*/ ctx[42],
				desc: true
			}
		});

	return {
		c() {
			create_component(sortabletable.$$.fragment);
		},
		l(nodes) {
			claim_component(sortabletable.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(sortabletable, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const sortabletable_changes = {};
			if (dirty[0] & /*states*/ 1) sortabletable_changes.items = /*states*/ ctx[0];
			sortabletable.$set(sortabletable_changes);
		},
		i(local) {
			if (current) return;
			transition_in(sortabletable.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(sortabletable.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(sortabletable, detaching);
		}
	};
}

// (1176:6) {#if pageType === 'state' && stateTableData}
function create_if_block(ctx) {
	let sortabletable0;
	let t0;
	let div;
	let t1;
	let a;
	let h2;
	let t2;
	let t3_value = /*currentState*/ ctx[8].name + "";
	let t3;
	let t4;
	let p;
	let t5;
	let t6_value = /*currentState*/ ctx[8].name + "";
	let t6;
	let t7;
	let t8;
	let sortabletable1;
	let current;

	sortabletable0 = new SortableTable({
			props: {
				items: /*stateTableData*/ ctx[1],
				pageSize: 10,
				sortBy: 'outageCustomers',
				columns: /*STATE_OUTAGE_COLUMNS*/ ctx[43],
				desc: true
			}
		});

	sortabletable1 = new SortableTable({
			props: {
				items: /*tableCounties*/ ctx[33],
				pageSize: 10,
				sortBy: 'outageCustomers',
				columns: /*COUNTY_OUTAGE_COLUMNS*/ ctx[44],
				desc: true
			}
		});

	return {
		c() {
			create_component(sortabletable0.$$.fragment);
			t0 = space();
			div = element("div");
			t1 = space();
			a = element("a");
			h2 = element("h2");
			t2 = text("Power Outage by County in ");
			t3 = text(t3_value);
			t4 = space();
			p = element("p");
			t5 = text("This table contains the customers out, total customers served, and when the data was last updated for every\n          county in ");
			t6 = text(t6_value);
			t7 = text(".");
			t8 = space();
			create_component(sortabletable1.$$.fragment);
			this.h();
		},
		l(nodes) {
			claim_component(sortabletable0.$$.fragment, nodes);
			t0 = claim_space(nodes);

			div = claim_element(nodes, "DIV", {
				class: true,
				"aria-hidden": true,
				style: true
			});

			children(div).forEach(detach);
			t1 = claim_space(nodes);
			a = claim_element(nodes, "A", { id: true });
			var a_nodes = children(a);
			h2 = claim_element(a_nodes, "H2", {});
			var h2_nodes = children(h2);
			t2 = claim_text(h2_nodes, "Power Outage by County in ");
			t3 = claim_text(h2_nodes, t3_value);
			h2_nodes.forEach(detach);
			a_nodes.forEach(detach);
			t4 = claim_space(nodes);
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t5 = claim_text(p_nodes, "This table contains the customers out, total customers served, and when the data was last updated for every\n          county in ");
			t6 = claim_text(p_nodes, t6_value);
			t7 = claim_text(p_nodes, ".");
			p_nodes.forEach(detach);
			t8 = claim_space(nodes);
			claim_component(sortabletable1.$$.fragment, nodes);
			this.h();
		},
		h() {
			attr(div, "class", "spacer");
			attr(div, "aria-hidden", "true");
			set_style(div, "height", "40px");
			attr(a, "id", "county-list");
		},
		m(target, anchor) {
			mount_component(sortabletable0, target, anchor);
			insert_hydration(target, t0, anchor);
			insert_hydration(target, div, anchor);
			insert_hydration(target, t1, anchor);
			insert_hydration(target, a, anchor);
			append_hydration(a, h2);
			append_hydration(h2, t2);
			append_hydration(h2, t3);
			insert_hydration(target, t4, anchor);
			insert_hydration(target, p, anchor);
			append_hydration(p, t5);
			append_hydration(p, t6);
			append_hydration(p, t7);
			insert_hydration(target, t8, anchor);
			mount_component(sortabletable1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const sortabletable0_changes = {};
			if (dirty[0] & /*stateTableData*/ 2) sortabletable0_changes.items = /*stateTableData*/ ctx[1];
			sortabletable0.$set(sortabletable0_changes);
			if ((!current || dirty[0] & /*currentState*/ 256) && t3_value !== (t3_value = /*currentState*/ ctx[8].name + "")) set_data(t3, t3_value);
			if ((!current || dirty[0] & /*currentState*/ 256) && t6_value !== (t6_value = /*currentState*/ ctx[8].name + "")) set_data(t6, t6_value);
			const sortabletable1_changes = {};
			if (dirty[1] & /*tableCounties*/ 4) sortabletable1_changes.items = /*tableCounties*/ ctx[33];
			sortabletable1.$set(sortabletable1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(sortabletable0.$$.fragment, local);
			transition_in(sortabletable1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(sortabletable0.$$.fragment, local);
			transition_out(sortabletable1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(sortabletable0, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			if (detaching) detach(t1);
			if (detaching) detach(a);
			if (detaching) detach(t4);
			if (detaching) detach(p);
			if (detaching) detach(t8);
			destroy_component(sortabletable1, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div6;
	let t0;
	let t1;
	let t2;
	let div3;
	let div0;

	let t3_value = (/*loading*/ ctx[32]
	? `Loading ${/*statesAttempting*/ ctx[35].length + 1} data points, map may change rapidly.`
	: `View the map as of ${/*getAdjustedTime*/ ctx[39](/*sliderValue*/ ctx[11])}`) + "";

	let t3;
	let t4;
	let input;
	let t5;
	let div1;
	let t6;
	let div2;
	let t7;
	let t8;
	let inlinetextcta;
	let t9;
	let div5;
	let div4;
	let a;
	let h2;
	let t10;
	let t11;
	let t12;
	let t13;
	let t14;
	let poweroutagecta;
	let current;
	let mounted;
	let dispose;
	let if_block0 = /*pageType*/ ctx[2] === 'state' && create_if_block_17(ctx);
	let if_block1 = /*pageType*/ ctx[2] !== 'all' && create_if_block_16(ctx);
	let if_block2 = (/*pageType*/ ctx[2] === 'all' || /*pageType*/ ctx[2] === 'state') && create_if_block_9(ctx);
	let each_value_1 = /*tickHours*/ ctx[40];
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	let each_value = /*tickHours*/ ctx[40];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	let if_block3 = /*pageType*/ ctx[2] !== 'all' && create_if_block_3(ctx);
	inlinetextcta = new InlineTextCta({});

	function select_block_type_3(ctx, dirty) {
		if (/*pageType*/ ctx[2] === 'state') return create_if_block_2;
		return create_else_block;
	}

	let current_block_type = select_block_type_3(ctx, [-1, -1, -1, -1]);
	let if_block4 = current_block_type(ctx);
	let if_block5 = /*pageType*/ ctx[2] === 'all' && create_if_block_1(ctx);
	let if_block6 = /*pageType*/ ctx[2] === 'state' && /*stateTableData*/ ctx[1] && create_if_block(ctx);
	poweroutagecta = new PowerOutageCta({});

	return {
		c() {
			div6 = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			if (if_block2) if_block2.c();
			t2 = space();
			div3 = element("div");
			div0 = element("div");
			t3 = text(t3_value);
			t4 = space();
			input = element("input");
			t5 = space();
			div1 = element("div");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t6 = space();
			div2 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t7 = space();
			if (if_block3) if_block3.c();
			t8 = space();
			create_component(inlinetextcta.$$.fragment);
			t9 = space();
			div5 = element("div");
			div4 = element("div");
			a = element("a");
			h2 = element("h2");
			t10 = text(/*h2Title*/ ctx[7]);
			t11 = space();
			if_block4.c();
			t12 = space();
			if (if_block5) if_block5.c();
			t13 = space();
			if (if_block6) if_block6.c();
			t14 = space();
			create_component(poweroutagecta.$$.fragment);
			this.h();
		},
		l(nodes) {
			div6 = claim_element(nodes, "DIV", { class: true });
			var div6_nodes = children(div6);
			if (if_block0) if_block0.l(div6_nodes);
			t0 = claim_space(div6_nodes);
			if (if_block1) if_block1.l(div6_nodes);
			t1 = claim_space(div6_nodes);
			if (if_block2) if_block2.l(div6_nodes);
			t2 = claim_space(div6_nodes);
			div3 = claim_element(div6_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			div0 = claim_element(div3_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			t3 = claim_text(div0_nodes, t3_value);
			div0_nodes.forEach(detach);
			t4 = claim_space(div3_nodes);

			input = claim_element(div3_nodes, "INPUT", {
				type: true,
				min: true,
				max: true,
				class: true,
				step: true
			});

			t5 = claim_space(div3_nodes);
			div1 = claim_element(div3_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].l(div1_nodes);
			}

			div1_nodes.forEach(detach);
			t6 = claim_space(div3_nodes);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div2_nodes);
			}

			div2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			t7 = claim_space(div6_nodes);
			if (if_block3) if_block3.l(div6_nodes);
			t8 = claim_space(div6_nodes);
			claim_component(inlinetextcta.$$.fragment, div6_nodes);
			t9 = claim_space(div6_nodes);
			div5 = claim_element(div6_nodes, "DIV", { class: true });
			var div5_nodes = children(div5);
			div4 = claim_element(div5_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			a = claim_element(div4_nodes, "A", { id: true });
			var a_nodes = children(a);
			h2 = claim_element(a_nodes, "H2", {});
			var h2_nodes = children(h2);
			t10 = claim_text(h2_nodes, /*h2Title*/ ctx[7]);
			h2_nodes.forEach(detach);
			a_nodes.forEach(detach);
			t11 = claim_space(div4_nodes);
			if_block4.l(div4_nodes);
			t12 = claim_space(div4_nodes);
			if (if_block5) if_block5.l(div4_nodes);
			t13 = claim_space(div4_nodes);
			if (if_block6) if_block6.l(div4_nodes);
			div4_nodes.forEach(detach);
			div5_nodes.forEach(detach);
			t14 = claim_space(div6_nodes);
			claim_component(poweroutagecta.$$.fragment, div6_nodes);
			div6_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div0, "class", "time-display svelte-6mapeg");
			attr(input, "type", "range");
			attr(input, "min", "0");
			attr(input, "max", "71");
			attr(input, "class", "slider svelte-6mapeg");
			attr(input, "step", "1");
			attr(div1, "class", "tick-marks svelte-6mapeg");
			attr(div2, "class", "labels svelte-6mapeg");
			attr(div3, "class", "slider-container svelte-6mapeg");
			attr(a, "id", "utility-list");
			attr(div4, "class", "order-2");
			attr(div5, "class", "row mb-5 mt-4");
			attr(div6, "class", "row mb-5");
		},
		m(target, anchor) {
			insert_hydration(target, div6, anchor);
			if (if_block0) if_block0.m(div6, null);
			append_hydration(div6, t0);
			if (if_block1) if_block1.m(div6, null);
			append_hydration(div6, t1);
			if (if_block2) if_block2.m(div6, null);
			append_hydration(div6, t2);
			append_hydration(div6, div3);
			append_hydration(div3, div0);
			append_hydration(div0, t3);
			append_hydration(div3, t4);
			append_hydration(div3, input);
			set_input_value(input, /*sliderValue*/ ctx[11]);
			append_hydration(div3, t5);
			append_hydration(div3, div1);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(div1, null);
			}

			append_hydration(div3, t6);
			append_hydration(div3, div2);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div2, null);
			}

			append_hydration(div6, t7);
			if (if_block3) if_block3.m(div6, null);
			append_hydration(div6, t8);
			mount_component(inlinetextcta, div6, null);
			append_hydration(div6, t9);
			append_hydration(div6, div5);
			append_hydration(div5, div4);
			append_hydration(div4, a);
			append_hydration(a, h2);
			append_hydration(h2, t10);
			append_hydration(div4, t11);
			if_block4.m(div4, null);
			append_hydration(div4, t12);
			if (if_block5) if_block5.m(div4, null);
			append_hydration(div4, t13);
			if (if_block6) if_block6.m(div4, null);
			append_hydration(div6, t14);
			mount_component(poweroutagecta, div6, null);
			current = true;

			if (!mounted) {
				dispose = [
					listen(input, "change", /*input_change_input_handler*/ ctx[68]),
					listen(input, "input", /*input_change_input_handler*/ ctx[68])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (/*pageType*/ ctx[2] === 'state') {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[0] & /*pageType*/ 4) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_17(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div6, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*pageType*/ ctx[2] !== 'all') {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_16(ctx);
					if_block1.c();
					if_block1.m(div6, t1);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*pageType*/ ctx[2] === 'all' || /*pageType*/ ctx[2] === 'state') {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*pageType*/ 4) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_9(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div6, t2);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if ((!current || dirty[0] & /*sliderValue*/ 2048 | dirty[1] & /*loading, statesAttempting*/ 18) && t3_value !== (t3_value = (/*loading*/ ctx[32]
			? `Loading ${/*statesAttempting*/ ctx[35].length + 1} data points, map may change rapidly.`
			: `View the map as of ${/*getAdjustedTime*/ ctx[39](/*sliderValue*/ ctx[11])}`) + "")) set_data(t3, t3_value);

			if (dirty[0] & /*sliderValue*/ 2048) {
				set_input_value(input, /*sliderValue*/ ctx[11]);
			}

			if (dirty[1] & /*tickHours*/ 512) {
				each_value_1 = /*tickHours*/ ctx[40];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(div1, null);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}

				each_blocks_1.length = each_value_1.length;
			}

			if (dirty[1] & /*tickHours, getLabel*/ 1536) {
				each_value = /*tickHours*/ ctx[40];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div2, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (/*pageType*/ ctx[2] !== 'all') {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_3(ctx);
					if_block3.c();
					if_block3.m(div6, t8);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (!current || dirty[0] & /*h2Title*/ 128) set_data(t10, /*h2Title*/ ctx[7]);

			if (current_block_type === (current_block_type = select_block_type_3(ctx, dirty)) && if_block4) {
				if_block4.p(ctx, dirty);
			} else {
				if_block4.d(1);
				if_block4 = current_block_type(ctx);

				if (if_block4) {
					if_block4.c();
					if_block4.m(div4, t12);
				}
			}

			if (/*pageType*/ ctx[2] === 'all') {
				if (if_block5) {
					if_block5.p(ctx, dirty);

					if (dirty[0] & /*pageType*/ 4) {
						transition_in(if_block5, 1);
					}
				} else {
					if_block5 = create_if_block_1(ctx);
					if_block5.c();
					transition_in(if_block5, 1);
					if_block5.m(div4, t13);
				}
			} else if (if_block5) {
				group_outros();

				transition_out(if_block5, 1, 1, () => {
					if_block5 = null;
				});

				check_outros();
			}

			if (/*pageType*/ ctx[2] === 'state' && /*stateTableData*/ ctx[1]) {
				if (if_block6) {
					if_block6.p(ctx, dirty);

					if (dirty[0] & /*pageType, stateTableData*/ 6) {
						transition_in(if_block6, 1);
					}
				} else {
					if_block6 = create_if_block(ctx);
					if_block6.c();
					transition_in(if_block6, 1);
					if_block6.m(div4, null);
				}
			} else if (if_block6) {
				group_outros();

				transition_out(if_block6, 1, 1, () => {
					if_block6 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block2);
			transition_in(inlinetextcta.$$.fragment, local);
			transition_in(if_block5);
			transition_in(if_block6);
			transition_in(poweroutagecta.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block2);
			transition_out(inlinetextcta.$$.fragment, local);
			transition_out(if_block5);
			transition_out(if_block6);
			transition_out(poweroutagecta.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div6);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			destroy_each(each_blocks_1, detaching);
			destroy_each(each_blocks, detaching);
			if (if_block3) if_block3.d();
			destroy_component(inlinetextcta);
			if_block4.d();
			if (if_block5) if_block5.d();
			if (if_block6) if_block6.d();
			destroy_component(poweroutagecta);
			mounted = false;
			run_all(dispose);
		}
	};
}

function formatDateFull(date) {
	const options = {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		hour12: true
	};

	return date.toLocaleString('en-US', options);
}

// Function to format the hour only with AM/PM
function formatHour(date) {
	const options = {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
		hour: 'numeric',
		hour12: true
	};

	return date.toLocaleString('en-US', options);
}

function calculateScrapedAtTime(sliderValue) {
	const currentDate = new Date();
	currentDate.setHours(currentDate.getHours() - sliderValue);
	return currentDate.toISOString().split(':')[0] + ':00:00+00:00';
}

function instance($$self, $$props, $$invalidate) {
	let $zoom;
	let $coords;
	let { id } = $$props;
	let { pageType = '' } = $$props;
	let { slug = '' } = $$props;
	let { states } = $$props;
	let { classes = '' } = $$props;
	let { height = 500 } = $$props;
	let { width = 960 } = $$props;
	let { colorPrefix = 'p' } = $$props;
	let { disableStateZoom = false } = $$props;
	let { stateTableData = [] } = $$props;
	let { untrackProviderData = [] } = $$props;
	let { h2Title = '' } = $$props;
	let { currentState = {} } = $$props;
	let { dataPoints } = $$props;
	let { mapStrokeColor = '' } = $$props;
	let { countyCount, stateOutageRank, highestRatio, utilityCount, providerHighestOutages, statePercentOut, totalCustomers, totalCustomersOut, lastUpdated, countyWithHighestOutages, highestRatioCounty, providerHighestRatio, peakCustomersOut, averageCustomersOut, customerOutChange, peakCustomersOutPercentage } = dataPoints ?? {};
	const isDev = process.env.componentType === 'browser' && window && window.location.hostname.includes('localhost');
	const isBrowser = process.env.componentType === 'browser';
	let nationalInfo;
	let initialCountryOut;
	let selected;
	let hoveredEntity;
	let hoverX, hoverY;
	let liveStates = [];
	let allStates = [];
	let stateDataFetched = new Set(); // track fetched state
	let loading = false;
	let fetchedStateData = {};
	let sliderValue = 0;
	let currentTime = new Date();

	// Function to get the adjusted time based on slider value
	function getAdjustedTime(hoursAgo) {
		let adjustedTime = new Date(currentTime);
		adjustedTime.setHours(currentTime.getHours() - hoursAgo);

		return hoursAgo === 0
		? formatDateFull(adjustedTime)
		: formatHour(adjustedTime);
	}

	// Array for only selected tick positions
	const tickHours = [71, 60, 48, 36, 24, 12, 0];

	function getLabel(hour) {
		if (tickHours.includes(hour)) return hour == 0 ? 'Live' : `${hour}h`;
		return '';
	}

	const graphql = getGraphqlClient();

	const OUTAGE_TABLE_COLUMNS = [
		{
			property: 'stateName',
			label: 'State',
			formatter: 'providerConditionalLink'
		},
		{
			property: 'outageCustomers',
			label: 'Customers Out',
			formatter: 'number'
		}
	];

	const STATE_OUTAGE_COLUMNS = [
		{
			property: 'companyNameSeo',
			label: 'Provider',
			formatter: 'providerConditionalLink'
		},
		{
			property: 'outageCustomers',
			label: 'Customers Out',
			formatter: 'number'
		},
		{
			property: 'servedCustomers',
			label: 'Est. Customers Served',
			formatter: 'number'
		},
		{
			property: 'updatedAt',
			label: 'Last Updated',
			formatter: 'string'
		}
	];

	const UNKNOWN_PROVIDER_COLUMNS = [
		{
			property: 'companyNameSeo',
			label: 'Provider',
			formatter: 'providerConditionalLink'
		},
		{
			property: 'servedCustomers',
			label: 'Est. Customers Served',
			formatter: 'number'
		},
		{
			property: 'website',
			label: 'Website',
			formatter: 'url'
		},
		{
			property: 'outageMapUrl',
			label: 'Outage Map',
			formatter: 'url'
		},
		{
			property: 'coverageMap',
			label: 'Coverage Map',
			formatter: 'providerCoverageUrl'
		}
	];

	const COUNTY_OUTAGE_COLUMNS = [
		{
			property: 'countyName',
			label: 'County',
			formatter: 'countyLink'
		},
		{
			property: 'outageCustomers',
			label: 'Customers Out',
			formatter: 'number'
		},
		{
			property: 'servedCustomers',
			label: 'Est. Customers Served',
			formatter: 'number'
		},
		{
			property: 'scrapedAt',
			label: 'Last Updated',
			formatter: 'string'
		}
	];

	const HISTORICAL_OUTAGE_COLUMNS = [
		{
			property: 'scrapedAt',
			label: 'Outage Time',
			formatter: 'string',
			sortProperty: 'sortableTimestamp'
		},
		{
			property: 'outageCustomers',
			label: 'Customers Out',
			formatter: 'number'
		},
		{
			property: 'servedCustomers',
			label: 'Est. Customers Served',
			formatter: 'number'
		},
		{
			property: 'percentOut',
			label: 'Percent Customers Out',
			formatter: 'number'
		}
	];

	// if used to show just a specific state
	if (pageType === 'state') {
		selected = slug;
	}

	let egKey = '';
	let errors;

	const getOutages = gql`
    query stateOutages($orderBy: [StateOutageDataOrderBy!]) {
      outages: allStateOutageData(orderBy: $orderBy) {
        nodes {
          stateId
          outageCustomers
          servedCustomers
          scrapedAt
        }
      }
    }
  `;

	const getStateOutage = gql`
    query stateOutage($id: Int!) {
      outages: allProviderStateOutageData(condition: { stateId: $id }) {
        nodes {
          providerName
          providerSlug
          website
          outageMapUrl
          providerTracked
          outageCustomers
          servedCustomers
          scrapedAt
        }
      }
    }
  `;

	const getHistorialStateOutageStats = gql`
    query historicalStateOutage($id: Int!) {
      outages: allStateRecentOutageStats(condition: { stateId: $id }) {
        nodes {
          avgOutageCustomers
          peakOutageCustomers
          changeOutageCustomers
          peakOutageCustomersFraction
        }
      }
    }
  `;

	const getPeriodicalStateOutage = gql`
    query periodicalStateOutage($scrapedAt: Datetime!) {
      outages: allStateRecentOutageData(condition: { scrapedAt: $scrapedAt }, orderBy: STATE_ID_ASC) {
        nodes {
          stateId
          outageCustomers
          servedCustomers
          scrapedAt
        }
      }
    }
  `;

	const getPeriodicalCountyStateOutage = gql`
    query periodicalCountyRecentOutage($slug: String!, $scrapedAt: Datetime!) {
      outages: allCountyRecentOutageData(condition: { stateSlug: $slug, scrapedAt: $scrapedAt }) {
        nodes {
          countyName
          countySlug
          stateSlug
          outageCustomers
          servedCustomers
          scrapedAt
        }
      }
    }
  `;

	// Update map function (adjust map based on slider value)
	const updateMap = async sliderValue => {
		const scrapedAt = calculateScrapedAtTime(sliderValue);

		if (sliderValue === 0) {
			$$invalidate(0, states = liveStates.length > 0 ? liveStates : states);

			$$invalidate(28, nationalInfo = initialCountryOut
			? initialCountryOut
			: totalCustomersOut);
		} else if (stateDataFetched.has(sliderValue)) {
			if (pageType === 'state') {
				$$invalidate(0, states = allStates.filter(o => o.scrapedAt === scrapedAt));
				$$invalidate(28, nationalInfo = allStates.find(o => o.stateId === id && o.scrapedAt === scrapedAt).outageCustomers);
			} else {
				$$invalidate(28, nationalInfo = 0);

				$$invalidate(0, states = allStates.filter(o => {
					if (o.scrapedAt === scrapedAt) {
						$$invalidate(28, nationalInfo += o.outageCustomers);
						return true;
					}

					return false;
				}));
			}
		} else {
			const result = await graphql(getPeriodicalStateOutage({ scrapedAt }), { 'eg-key': egKey });

			if (result.errors) {
				errors = result.errors;
			} else {
				stateDataFetched.add(sliderValue);
			}

			const statesOutages = result.data.outages.nodes;
			$$invalidate(28, nationalInfo = 0);

			$$invalidate(0, states = states.map(state => {
				const outage = statesOutages.find(e => e.stateId === state.stateId);
				$$invalidate(28, nationalInfo += outage.outageCustomers);

				return {
					...state,
					scrapedAt: outage.scrapedAt,
					outageCustomers: outage.outageCustomers,
					servedCustomers: outage.servedCustomers,
					permalink: `${isDev ? '/dev' : ''}/${state.slug}/power-outage/`
				};
			}));

			allStates = [...allStates, ...states];
		}
	};

	const handleCountryPageOnMount = async () => {
		const re = await graphql(getOutages({ orderBy: 'STATE_ID_ASC' }), { 'eg-key': egKey });

		if (re.errors) {
			errors = re.errors;
		}

		const outages = re.data.outages.nodes;
		$$invalidate(28, nationalInfo = 0);

		$$invalidate(0, states = states.map(state => {
			const outage = outages.find(e => e.stateId === state.stateId);
			$$invalidate(28, nationalInfo += outage.outageCustomers);

			return {
				...state,
				outageCustomers: outage.outageCustomers,
				servedCustomers: outage.servedCustomers,
				permalink: `${isDev ? '/dev' : ''}/${state.slug}/power-outage/`
			};
		}));

		initialCountryOut = nationalInfo;
	};

	let tableCounties = [];

	const handleStatePageOnMount = async (id, slug, egKey) => {
		const stateOutages = await graphql(getStateOutage({ id }), { 'eg-key': egKey });

		if (stateOutages.errors) {
			errors = stateOutages.errors;
		}

		const outages = stateOutages.data.outages.nodes;
		const re = await graphql(getOutages({ orderBy: 'STATE_ID_ASC' }), { 'eg-key': egKey });

		if (re.errors) {
			errors = re.errors;
		}

		const statesOutages = re.data.outages.nodes;

		$$invalidate(0, states = states.map(state => {
			const outage = statesOutages.find(e => e.stateId === state.stateId);

			const ratio = outage.servedCustomers && outage.servedCustomers !== 0
			? Number((outage.outageCustomers / outage.servedCustomers * 100).toFixed(2))
			: 0;

			return {
				...state,
				outageCustomers: outage.outageCustomers,
				servedCustomers: outage.servedCustomers,
				ratio,
				permalink: `${isDev ? '/dev' : ''}/${state.slug}/power-outage/`
			};
		}));

		$$invalidate(14, highestRatio = states.sort((a, b) => b.ratio - a.ratio).findIndex(state => state.stateId === id) + 1);
		$$invalidate(13, stateOutageRank = states.sort((a, b) => b.outageCustomers - a.outageCustomers).findIndex(state => state.stateId === id) + 1);
		liveStates = states;
		const countyOutages = await graphql(getTableCounties({ slug }), { 'eg-key': egKey });
		const cOutages = countyOutages.data.outages.nodes;

		if (countyOutages.errors) {
			errors.push(...countyOutages.errors);
		}

		if (tableCounties.length === 0) {
			$$invalidate(33, tableCounties = cOutages.map(county => {
				const ratio = county.servedCustomers && county.servedCustomers !== 0
				? Number((county.outageCustomers / county.servedCustomers * 100).toFixed(2))
				: 0;

				return {
					...county,
					ratio,
					permalink: `${isDev ? '/dev' : ''}/${county.stateSlug}/${county.countySlug}-electricity/power-outage/`,
					name: county.countyName,
					scrapedAt: formatDateTimeForText(new Date(county.scrapedAt))
				};
			}));
		}

		$$invalidate(12, countyCount);

		$$invalidate(22, highestRatioCounty = tableCounties.reduce(
			(maxCounty, currentCounty) => {
				return currentCounty.ratio > (maxCounty?.ratio || 0)
				? currentCounty
				: maxCounty;
			},
			null
		));

		// used reduce to get highest
		$$invalidate(21, countyWithHighestOutages = tableCounties.reduce(
			(maxCounty, currentCounty) => {
				return currentCounty.outageCustomers > (maxCounty?.outageCustomers || 0)
				? currentCounty
				: maxCounty;
			},
			null
		));

		const historicalStateStats = await graphql(getHistorialStateOutageStats({ id }), { 'eg-key': egKey });

		if (historicalStateStats.errors) {
			errors = historicalStateStats.errors;
		}

		$$invalidate(24, peakCustomersOut = historicalStateStats.data.outages.nodes[0].peakOutageCustomers);
		$$invalidate(27, peakCustomersOutPercentage = Number(100 * historicalStateStats.data.outages.nodes[0].peakOutageCustomersFraction).toFixed(2));
		$$invalidate(25, averageCustomersOut = Math.round(historicalStateStats.data.outages.nodes[0].avgOutageCustomers));
		$$invalidate(26, customerOutChange = historicalStateStats.data.outages.nodes[0].changeOutageCustomers);
		const stateOutageData = [];
		const unknownOutageData = [];
		let totalOutageCustomers = 0;
		$$invalidate(20, lastUpdated = null);
		let totalServedCustomers = 0;

		outages.forEach(({ providerName, scrapedAt, outageCustomers, outageMapUrl, providerSlug, providerTracked, servedCustomers, website }) => {
			totalServedCustomers += Number(servedCustomers);
			totalOutageCustomers += Number(outageCustomers);
			$$invalidate(20, lastUpdated = new Date(Math.max(new Date(scrapedAt), lastUpdated)));

			if (providerTracked) {
				const ratio = servedCustomers && servedCustomers !== 0
				? Number((outageCustomers / servedCustomers * 100).toFixed(2))
				: 0;

				stateOutageData.push({
					companyNameSeo: providerName,
					outageCustomers,
					servedCustomers,
					ratio,
					permalink: `${isDev ? '/dev' : ''}/providers/${providerSlug}/power-outage/`,
					updatedAt: formatDateTimeForText(new Date(scrapedAt))
				});
			} else {
				unknownOutageData.push({
					companyNameSeo: providerName,
					servedCustomers,
					website,
					outageMapUrl,
					coverageMap: `${isDev ? '/dev' : ''}/providers/${providerSlug}#map`,
					permalink: ''
				});
			}
		});

		$$invalidate(18, totalCustomers = totalServedCustomers);
		$$invalidate(19, totalCustomersOut = totalOutageCustomers);
		$$invalidate(28, nationalInfo = totalOutageCustomers);
		$$invalidate(20, lastUpdated = formatDateTimeForText(lastUpdated));
		$$invalidate(1, stateTableData = stateOutageData);
		$$invalidate(15, utilityCount);
		$$invalidate(17, statePercentOut = Number(Number(100 * totalCustomersOut / totalCustomers).toFixed(2)));
		$$invalidate(55, untrackProviderData = unknownOutageData);

		$$invalidate(23, providerHighestRatio = stateTableData.reduce(
			(maxProvider, currentProvider) => {
				return currentProvider.ratio > (maxProvider?.ratio || 0)
				? currentProvider
				: maxProvider;
			},
			null
		));

		$$invalidate(16, providerHighestOutages = stateTableData.reduce(
			(maxProvider, currentProvider) => {
				return currentProvider.outageCustomers > (maxProvider?.outageCustomers || 0)
				? currentProvider
				: maxProvider;
			},
			null
		));
	};

	// Function to check the value of the variable
	function checkStatesAttempting() {
		if (statesAttempting.length > 0) {
			$$invalidate(32, loading = true);
		} else if (loading === true) {
			$$invalidate(32, loading = false); // just so loading isn't constantly being set
		}

		$$invalidate(35, statesAttempting);
	}

	let mounted = false;

	onMount(async () => {
		const egKeyDiv = document.getElementById('eg-key');
		if (egKeyDiv) egKey = egKeyDiv.dataset.egKey;
		$$invalidate(60, mounted = true);

		if (pageType === 'all') {
			await handleCountryPageOnMount();
		}

		if (slug) {
			await ensureStateData(slug, sliderValue);
		}

		if (pageType === 'state' && id) {
			await handleStatePageOnMount(id, slug, egKey);
		}

		setInterval(checkStatesAttempting, 300);
	});

	const getStateOutageColorClass = customersOut => {
		let i = 10 - Math.ceil(Number(customersOut) / 5000);
		if (i <= 0) i = 1;
		return `${colorPrefix}${i}-fill`;
	};

	const getCountyOutageColorClass = (customersOut, customersServed) => {
		const outagePercentage = customersOut / customersServed * 100;

		if (outagePercentage === 0) {
			return `${colorPrefix}10-fill`;
		}

		const step = Math.min(Math.floor(outagePercentage / 2.5) + 1, 9);
		return `${colorPrefix}${10 - step}-fill`;
	};

	const getTableCounties = gql`
    query countyOutages($slug: String!) {
      outages: allCountyStateOutageData(condition: { stateSlug: $slug }) {
        nodes {
          countyName
          countySlug
          stateSlug
          outageCustomers
          servedCustomers
          scrapedAt
        }
      }
    }
  `;

	const getCounties = gql`
    query countyOutages($slug: String!) {
      outages: allCountyStateOutageData(condition: { stateSlug: $slug }) {
        nodes {
          countyName
          svgPath
          countySlug
          stateSlug
          outageCustomers
          servedCustomers
          scrapedAt
        }
      }
    }
  `;

	let counties = [];
	const statesWithCountyData = [];
	let statesAttempting = [];
	let initialCountyData = [];

	async function ensureStateData(slug = slug, sliderValue = 0) {
		const fetchKey = `${slug}_${sliderValue}`;

		if (statesAttempting.includes(fetchKey) || fetchedStateData[fetchKey]) {
			if (fetchedStateData[fetchKey]) {
				// Check if data has already been fetched for the given slider value, ignoring stateSlug
				const matchedDataKeys = Object.keys(fetchedStateData).filter(key => key.endsWith(`_${sliderValue}`));

				const matchedData = matchedDataKeys.flatMap(key => fetchedStateData[key]);
				$$invalidate(34, counties = matchedData);
			}

			return;
		}

		statesAttempting.push(fetchKey);

		try {
			if (sliderValue === 0 || !statesWithCountyData.includes(slug)) {
				if (statesWithCountyData.includes(slug)) {
					statesAttempting.splice(statesAttempting.indexOf(fetchKey), 1);
					return; // Live data already fetched
				}

				const r = await graphql(getCounties({ slug }), { 'eg-key': egKey });

				if (!r || !r.data || !r.data.outages) {
					throw new Error(`Invalid response for live data: ${JSON.stringify(r)}`);
				}

				const countyOutages = r.data.outages.nodes;
				initialCountyData = [...initialCountyData, ...countyOutages];
				$$invalidate(34, counties = initialCountyData); // Assign live data
				fetchedStateData[fetchKey] = countyOutages;
				statesWithCountyData.push(slug); // Mark live data fetched
			} else {
				//  Handle historical data when slider`Value is not 0
				const scrapedAt = calculateScrapedAtTime(sliderValue);

				const r = await graphql(getPeriodicalCountyStateOutage({ slug, scrapedAt }), { 'eg-key': egKey });

				if (!r || !r.data || !r.data.outages.nodes) {
					throw new Error(`Invalid response for historical data: ${JSON.stringify(r)}`);
				}

				const fetchedCounties = r.data.outages.nodes || [];

				if (fetchedCounties.length === 0) {
					console.log('handle the error ');
				}

				// Merge svgPath from initialCountyData with historical data
				const mergedCounties = fetchedCounties.map(county => {
					const initialCounty = initialCountyData.find(c => c.countySlug === county.countySlug && c.stateSlug === county.stateSlug);

					return {
						...county,
						svgPath: initialCounty.svgPath
					};
				});

				fetchedStateData[fetchKey] = mergedCounties;
				$$invalidate(34, counties = mergedCounties);
			}
		} catch(error) {
			console.error('Error fetching data for', slug, error);
			errors = error;
		} finally {
			statesAttempting.splice(statesAttempting.indexOf(fetchKey), 1);
		}
	}

	let coords = spring({ x: width / 2, y: height / 2 }, { stiffness: 0.08, damping: 0.9 });
	component_subscribe($$self, coords, value => $$invalidate(37, $coords = value));
	let zoom = spring(1, { stiffness: 0.08, damping: 0.7 });
	component_subscribe($$self, zoom, value => $$invalidate(36, $zoom = value));

	function resetZoom(event) {
		set_store_value(zoom, $zoom = 1, $zoom);
		set_store_value(coords, $coords = { x: width / 2, y: height / 2 }, $coords);
		$$invalidate(10, selected = false);
		$$invalidate(29, hoveredEntity = false);
	}

	function updateZoom(event) {
		if (!event.detail.bb || !event.detail.zoom) return;

		set_store_value(
			coords,
			$coords = {
				x: event.detail.bb[0],
				y: event.detail.bb[1]
			},
			$coords
		);

		set_store_value(zoom, $zoom = event.detail.zoom, $zoom);
	}

	async function handleStateClick(event, state) {
		if (disableStateZoom) {
			if (state.permalink) window.location = state.permalink;
			return;
		}

		$$invalidate(10, selected = state.slug);
		await ensureStateData(state.slug, sliderValue);
	}

	function handleEntityHover(event, entity) {
		$$invalidate(29, hoveredEntity = entity);
	}

	function positionHover(event) {
		let el;

		if (event.target.classList.contains('nh-map')) {
			el = event.target;
		} else {
			el = event.target.closest('.nh-map');
		}

		const pRect = el.getBoundingClientRect();
		$$invalidate(30, hoverX = event.clientX - pRect.left);
		$$invalidate(31, hoverY = event.clientY - pRect.top);
	}

	const click_handler = () => resetZoom();
	const mouseover_handler = (county, e) => handleEntityHover(e, county);

	const click_handler_1 = county => {
		window.location = `${window.location.origin}${isDev ? `/dev` : ''}/${county.stateSlug}/${county.countySlug}-electricity/power-outage/`;
	};

	const clicked_handler = (state, svelteEvent) => {
		handleStateClick(svelteEvent.detail.event, state);
	};

	const clicked_handler_1 = (state, svelteEvent) => {
		handleStateClick(svelteEvent.detail.event, state);
	};

	const hovered_handler = async (state, svelteEvent) => {
		if (!disableStateZoom) {
			await ensureStateData(state.slug, sliderValue);
		}

		handleEntityHover(svelteEvent.detail.event, state);
	};

	const mouseleave_handler = () => $$invalidate(29, hoveredEntity = false);

	function input_change_input_handler() {
		sliderValue = to_number(this.value);
		$$invalidate(11, sliderValue);
	}

	$$self.$$set = $$props => {
		if ('id' in $$props) $$invalidate(56, id = $$props.id);
		if ('pageType' in $$props) $$invalidate(2, pageType = $$props.pageType);
		if ('slug' in $$props) $$invalidate(57, slug = $$props.slug);
		if ('states' in $$props) $$invalidate(0, states = $$props.states);
		if ('classes' in $$props) $$invalidate(3, classes = $$props.classes);
		if ('height' in $$props) $$invalidate(4, height = $$props.height);
		if ('width' in $$props) $$invalidate(5, width = $$props.width);
		if ('colorPrefix' in $$props) $$invalidate(58, colorPrefix = $$props.colorPrefix);
		if ('disableStateZoom' in $$props) $$invalidate(6, disableStateZoom = $$props.disableStateZoom);
		if ('stateTableData' in $$props) $$invalidate(1, stateTableData = $$props.stateTableData);
		if ('untrackProviderData' in $$props) $$invalidate(55, untrackProviderData = $$props.untrackProviderData);
		if ('h2Title' in $$props) $$invalidate(7, h2Title = $$props.h2Title);
		if ('currentState' in $$props) $$invalidate(8, currentState = $$props.currentState);
		if ('dataPoints' in $$props) $$invalidate(59, dataPoints = $$props.dataPoints);
		if ('mapStrokeColor' in $$props) $$invalidate(9, mapStrokeColor = $$props.mapStrokeColor);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty[0] & /*sliderValue*/ 2048 | $$self.$$.dirty[1] & /*mounted*/ 536870912) {
			$: {
				if (isBrowser && mounted) {
					updateMap(sliderValue);
				}
			}
		}

		if ($$self.$$.dirty[0] & /*selected, sliderValue*/ 3072 | $$self.$$.dirty[1] & /*mounted*/ 536870912) {
			$: {
				if (isBrowser && mounted && selected) {
					ensureStateData(selected, sliderValue);
				}
			}
		}
	};

	return [
		states,
		stateTableData,
		pageType,
		classes,
		height,
		width,
		disableStateZoom,
		h2Title,
		currentState,
		mapStrokeColor,
		selected,
		sliderValue,
		countyCount,
		stateOutageRank,
		highestRatio,
		utilityCount,
		providerHighestOutages,
		statePercentOut,
		totalCustomers,
		totalCustomersOut,
		lastUpdated,
		countyWithHighestOutages,
		highestRatioCounty,
		providerHighestRatio,
		peakCustomersOut,
		averageCustomersOut,
		customerOutChange,
		peakCustomersOutPercentage,
		nationalInfo,
		hoveredEntity,
		hoverX,
		hoverY,
		loading,
		tableCounties,
		counties,
		statesAttempting,
		$zoom,
		$coords,
		isDev,
		getAdjustedTime,
		tickHours,
		getLabel,
		OUTAGE_TABLE_COLUMNS,
		STATE_OUTAGE_COLUMNS,
		COUNTY_OUTAGE_COLUMNS,
		getStateOutageColorClass,
		getCountyOutageColorClass,
		ensureStateData,
		coords,
		zoom,
		resetZoom,
		updateZoom,
		handleStateClick,
		handleEntityHover,
		positionHover,
		untrackProviderData,
		id,
		slug,
		colorPrefix,
		dataPoints,
		mounted,
		click_handler,
		mouseover_handler,
		click_handler_1,
		clicked_handler,
		clicked_handler_1,
		hovered_handler,
		mouseleave_handler,
		input_change_input_handler
	];
}

class ZoomableOutageMapTable extends SvelteComponent {
	constructor(options) {
		super();

		init(
			this,
			options,
			instance,
			create_fragment,
			safe_not_equal,
			{
				id: 56,
				pageType: 2,
				slug: 57,
				states: 0,
				classes: 3,
				height: 4,
				width: 5,
				colorPrefix: 58,
				disableStateZoom: 6,
				stateTableData: 1,
				untrackProviderData: 55,
				h2Title: 7,
				currentState: 8,
				dataPoints: 59,
				mapStrokeColor: 9
			},
			null,
			[-1, -1, -1, -1]
		);
	}
}

export default ZoomableOutageMapTable;